/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//assets.geilicdn.com/m/hudong/0.2.4/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(162);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ function(module, exports) {

	/*!
	 * vue-resource v1.0.3
	 * https://github.com/vuejs/vue-resource
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	/**
	 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
	 */
	
	var RESOLVED = 0;
	var REJECTED = 1;
	var PENDING = 2;
	
	function Promise$1(executor) {
	
	    this.state = PENDING;
	    this.value = undefined;
	    this.deferred = [];
	
	    var promise = this;
	
	    try {
	        executor(function (x) {
	            promise.resolve(x);
	        }, function (r) {
	            promise.reject(r);
	        });
	    } catch (e) {
	        promise.reject(e);
	    }
	}
	
	Promise$1.reject = function (r) {
	    return new Promise$1(function (resolve, reject) {
	        reject(r);
	    });
	};
	
	Promise$1.resolve = function (x) {
	    return new Promise$1(function (resolve, reject) {
	        resolve(x);
	    });
	};
	
	Promise$1.all = function all(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        var count = 0,
	            result = [];
	
	        if (iterable.length === 0) {
	            resolve(result);
	        }
	
	        function resolver(i) {
	            return function (x) {
	                result[i] = x;
	                count += 1;
	
	                if (count === iterable.length) {
	                    resolve(result);
	                }
	            };
	        }
	
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
	        }
	    });
	};
	
	Promise$1.race = function race(iterable) {
	    return new Promise$1(function (resolve, reject) {
	        for (var i = 0; i < iterable.length; i += 1) {
	            Promise$1.resolve(iterable[i]).then(resolve, reject);
	        }
	    });
	};
	
	var p$1 = Promise$1.prototype;
	
	p$1.resolve = function resolve(x) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (x === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        var called = false;
	
	        try {
	            var then = x && x['then'];
	
	            if (x !== null && typeof x === 'object' && typeof then === 'function') {
	                then.call(x, function (x) {
	                    if (!called) {
	                        promise.resolve(x);
	                    }
	                    called = true;
	                }, function (r) {
	                    if (!called) {
	                        promise.reject(r);
	                    }
	                    called = true;
	                });
	                return;
	            }
	        } catch (e) {
	            if (!called) {
	                promise.reject(e);
	            }
	            return;
	        }
	
	        promise.state = RESOLVED;
	        promise.value = x;
	        promise.notify();
	    }
	};
	
	p$1.reject = function reject(reason) {
	    var promise = this;
	
	    if (promise.state === PENDING) {
	        if (reason === promise) {
	            throw new TypeError('Promise settled with itself.');
	        }
	
	        promise.state = REJECTED;
	        promise.value = reason;
	        promise.notify();
	    }
	};
	
	p$1.notify = function notify() {
	    var promise = this;
	
	    nextTick(function () {
	        if (promise.state !== PENDING) {
	            while (promise.deferred.length) {
	                var deferred = promise.deferred.shift(),
	                    onResolved = deferred[0],
	                    onRejected = deferred[1],
	                    resolve = deferred[2],
	                    reject = deferred[3];
	
	                try {
	                    if (promise.state === RESOLVED) {
	                        if (typeof onResolved === 'function') {
	                            resolve(onResolved.call(undefined, promise.value));
	                        } else {
	                            resolve(promise.value);
	                        }
	                    } else if (promise.state === REJECTED) {
	                        if (typeof onRejected === 'function') {
	                            resolve(onRejected.call(undefined, promise.value));
	                        } else {
	                            reject(promise.value);
	                        }
	                    }
	                } catch (e) {
	                    reject(e);
	                }
	            }
	        }
	    });
	};
	
	p$1.then = function then(onResolved, onRejected) {
	    var promise = this;
	
	    return new Promise$1(function (resolve, reject) {
	        promise.deferred.push([onResolved, onRejected, resolve, reject]);
	        promise.notify();
	    });
	};
	
	p$1.catch = function (onRejected) {
	    return this.then(undefined, onRejected);
	};
	
	/**
	 * Promise adapter.
	 */
	
	if (typeof Promise === 'undefined') {
	    window.Promise = Promise$1;
	}
	
	function PromiseObj(executor, context) {
	
	    if (executor instanceof Promise) {
	        this.promise = executor;
	    } else {
	        this.promise = new Promise(executor.bind(context));
	    }
	
	    this.context = context;
	}
	
	PromiseObj.all = function (iterable, context) {
	    return new PromiseObj(Promise.all(iterable), context);
	};
	
	PromiseObj.resolve = function (value, context) {
	    return new PromiseObj(Promise.resolve(value), context);
	};
	
	PromiseObj.reject = function (reason, context) {
	    return new PromiseObj(Promise.reject(reason), context);
	};
	
	PromiseObj.race = function (iterable, context) {
	    return new PromiseObj(Promise.race(iterable), context);
	};
	
	var p = PromiseObj.prototype;
	
	p.bind = function (context) {
	    this.context = context;
	    return this;
	};
	
	p.then = function (fulfilled, rejected) {
	
	    if (fulfilled && fulfilled.bind && this.context) {
	        fulfilled = fulfilled.bind(this.context);
	    }
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
	};
	
	p.catch = function (rejected) {
	
	    if (rejected && rejected.bind && this.context) {
	        rejected = rejected.bind(this.context);
	    }
	
	    return new PromiseObj(this.promise.catch(rejected), this.context);
	};
	
	p.finally = function (callback) {
	
	    return this.then(function (value) {
	        callback.call(this);
	        return value;
	    }, function (reason) {
	        callback.call(this);
	        return Promise.reject(reason);
	    });
	};
	
	/**
	 * Utility functions.
	 */
	
	var debug = false;var util = {};var slice = [].slice;
	
	
	function Util (Vue) {
	    util = Vue.util;
	    debug = Vue.config.debug || !Vue.config.silent;
	}
	
	function warn(msg) {
	    if (typeof console !== 'undefined' && debug) {
	        console.warn('[VueResource warn]: ' + msg);
	    }
	}
	
	function error(msg) {
	    if (typeof console !== 'undefined') {
	        console.error(msg);
	    }
	}
	
	function nextTick(cb, ctx) {
	    return util.nextTick(cb, ctx);
	}
	
	function trim(str) {
	    return str.replace(/^\s*|\s*$/g, '');
	}
	
	function toLower(str) {
	    return str ? str.toLowerCase() : '';
	}
	
	function toUpper(str) {
	    return str ? str.toUpperCase() : '';
	}
	
	var isArray = Array.isArray;
	
	function isString(val) {
	    return typeof val === 'string';
	}
	
	function isBoolean(val) {
	    return val === true || val === false;
	}
	
	function isFunction(val) {
	    return typeof val === 'function';
	}
	
	function isObject(obj) {
	    return obj !== null && typeof obj === 'object';
	}
	
	function isPlainObject(obj) {
	    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
	}
	
	function isBlob(obj) {
	    return typeof Blob !== 'undefined' && obj instanceof Blob;
	}
	
	function isFormData(obj) {
	    return typeof FormData !== 'undefined' && obj instanceof FormData;
	}
	
	function when(value, fulfilled, rejected) {
	
	    var promise = PromiseObj.resolve(value);
	
	    if (arguments.length < 2) {
	        return promise;
	    }
	
	    return promise.then(fulfilled, rejected);
	}
	
	function options(fn, obj, opts) {
	
	    opts = opts || {};
	
	    if (isFunction(opts)) {
	        opts = opts.call(obj);
	    }
	
	    return merge(fn.bind({ $vm: obj, $options: opts }), fn, { $options: opts });
	}
	
	function each(obj, iterator) {
	
	    var i, key;
	
	    if (obj && typeof obj.length == 'number') {
	        for (i = 0; i < obj.length; i++) {
	            iterator.call(obj[i], obj[i], i);
	        }
	    } else if (isObject(obj)) {
	        for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	                iterator.call(obj[key], obj[key], key);
	            }
	        }
	    }
	
	    return obj;
	}
	
	var assign = Object.assign || _assign;
	
	function merge(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source, true);
	    });
	
	    return target;
	}
	
	function defaults(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	
	        for (var key in source) {
	            if (target[key] === undefined) {
	                target[key] = source[key];
	            }
	        }
	    });
	
	    return target;
	}
	
	function _assign(target) {
	
	    var args = slice.call(arguments, 1);
	
	    args.forEach(function (source) {
	        _merge(target, source);
	    });
	
	    return target;
	}
	
	function _merge(target, source, deep) {
	    for (var key in source) {
	        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
	            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
	                target[key] = {};
	            }
	            if (isArray(source[key]) && !isArray(target[key])) {
	                target[key] = [];
	            }
	            _merge(target[key], source[key], deep);
	        } else if (source[key] !== undefined) {
	            target[key] = source[key];
	        }
	    }
	}
	
	/**
	 * Root Prefix Transform.
	 */
	
	function root (options, next) {
	
	    var url = next(options);
	
	    if (isString(options.root) && !url.match(/^(https?:)?\//)) {
	        url = options.root + '/' + url;
	    }
	
	    return url;
	}
	
	/**
	 * Query Parameter Transform.
	 */
	
	function query (options, next) {
	
	    var urlParams = Object.keys(Url.options.params),
	        query = {},
	        url = next(options);
	
	    each(options.params, function (value, key) {
	        if (urlParams.indexOf(key) === -1) {
	            query[key] = value;
	        }
	    });
	
	    query = Url.params(query);
	
	    if (query) {
	        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
	    }
	
	    return url;
	}
	
	/**
	 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
	 */
	
	function expand(url, params, variables) {
	
	    var tmpl = parse(url),
	        expanded = tmpl.expand(params);
	
	    if (variables) {
	        variables.push.apply(variables, tmpl.vars);
	    }
	
	    return expanded;
	}
	
	function parse(template) {
	
	    var operators = ['+', '#', '.', '/', ';', '?', '&'],
	        variables = [];
	
	    return {
	        vars: variables,
	        expand: function (context) {
	            return template.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function (_, expression, literal) {
	                if (expression) {
	
	                    var operator = null,
	                        values = [];
	
	                    if (operators.indexOf(expression.charAt(0)) !== -1) {
	                        operator = expression.charAt(0);
	                        expression = expression.substr(1);
	                    }
	
	                    expression.split(/,/g).forEach(function (variable) {
	                        var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable);
	                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
	                        variables.push(tmp[1]);
	                    });
	
	                    if (operator && operator !== '+') {
	
	                        var separator = ',';
	
	                        if (operator === '?') {
	                            separator = '&';
	                        } else if (operator !== '#') {
	                            separator = operator;
	                        }
	
	                        return (values.length !== 0 ? operator : '') + values.join(separator);
	                    } else {
	                        return values.join(',');
	                    }
	                } else {
	                    return encodeReserved(literal);
	                }
	            });
	        }
	    };
	}
	
	function getValues(context, operator, key, modifier) {
	
	    var value = context[key],
	        result = [];
	
	    if (isDefined(value) && value !== '') {
	        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
	            value = value.toString();
	
	            if (modifier && modifier !== '*') {
	                value = value.substring(0, parseInt(modifier, 10));
	            }
	
	            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	        } else {
	            if (modifier === '*') {
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            result.push(encodeValue(operator, value[k], k));
	                        }
	                    });
	                }
	            } else {
	                var tmp = [];
	
	                if (Array.isArray(value)) {
	                    value.filter(isDefined).forEach(function (value) {
	                        tmp.push(encodeValue(operator, value));
	                    });
	                } else {
	                    Object.keys(value).forEach(function (k) {
	                        if (isDefined(value[k])) {
	                            tmp.push(encodeURIComponent(k));
	                            tmp.push(encodeValue(operator, value[k].toString()));
	                        }
	                    });
	                }
	
	                if (isKeyOperator(operator)) {
	                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
	                } else if (tmp.length !== 0) {
	                    result.push(tmp.join(','));
	                }
	            }
	        }
	    } else {
	        if (operator === ';') {
	            result.push(encodeURIComponent(key));
	        } else if (value === '' && (operator === '&' || operator === '?')) {
	            result.push(encodeURIComponent(key) + '=');
	        } else if (value === '') {
	            result.push('');
	        }
	    }
	
	    return result;
	}
	
	function isDefined(value) {
	    return value !== undefined && value !== null;
	}
	
	function isKeyOperator(operator) {
	    return operator === ';' || operator === '&' || operator === '?';
	}
	
	function encodeValue(operator, value, key) {
	
	    value = operator === '+' || operator === '#' ? encodeReserved(value) : encodeURIComponent(value);
	
	    if (key) {
	        return encodeURIComponent(key) + '=' + value;
	    } else {
	        return value;
	    }
	}
	
	function encodeReserved(str) {
	    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
	        if (!/%[0-9A-Fa-f]/.test(part)) {
	            part = encodeURI(part);
	        }
	        return part;
	    }).join('');
	}
	
	/**
	 * URL Template (RFC 6570) Transform.
	 */
	
	function template (options) {
	
	    var variables = [],
	        url = expand(options.url, options.params, variables);
	
	    variables.forEach(function (key) {
	        delete options.params[key];
	    });
	
	    return url;
	}
	
	/**
	 * Service for URL templating.
	 */
	
	var ie = document.documentMode;
	var el = document.createElement('a');
	
	function Url(url, params) {
	
	    var self = this || {},
	        options = url,
	        transform;
	
	    if (isString(url)) {
	        options = { url: url, params: params };
	    }
	
	    options = merge({}, Url.options, self.$options, options);
	
	    Url.transforms.forEach(function (handler) {
	        transform = factory(handler, transform, self.$vm);
	    });
	
	    return transform(options);
	}
	
	/**
	 * Url options.
	 */
	
	Url.options = {
	    url: '',
	    root: null,
	    params: {}
	};
	
	/**
	 * Url transforms.
	 */
	
	Url.transforms = [template, query, root];
	
	/**
	 * Encodes a Url parameter string.
	 *
	 * @param {Object} obj
	 */
	
	Url.params = function (obj) {
	
	    var params = [],
	        escape = encodeURIComponent;
	
	    params.add = function (key, value) {
	
	        if (isFunction(value)) {
	            value = value();
	        }
	
	        if (value === null) {
	            value = '';
	        }
	
	        this.push(escape(key) + '=' + escape(value));
	    };
	
	    serialize(params, obj);
	
	    return params.join('&').replace(/%20/g, '+');
	};
	
	/**
	 * Parse a URL and return its components.
	 *
	 * @param {String} url
	 */
	
	Url.parse = function (url) {
	
	    if (ie) {
	        el.href = url;
	        url = el.href;
	    }
	
	    el.href = url;
	
	    return {
	        href: el.href,
	        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
	        port: el.port,
	        host: el.host,
	        hostname: el.hostname,
	        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
	        search: el.search ? el.search.replace(/^\?/, '') : '',
	        hash: el.hash ? el.hash.replace(/^#/, '') : ''
	    };
	};
	
	function factory(handler, next, vm) {
	    return function (options) {
	        return handler.call(vm, options, next);
	    };
	}
	
	function serialize(params, obj, scope) {
	
	    var array = isArray(obj),
	        plain = isPlainObject(obj),
	        hash;
	
	    each(obj, function (value, key) {
	
	        hash = isObject(value) || isArray(value);
	
	        if (scope) {
	            key = scope + '[' + (plain || hash ? key : '') + ']';
	        }
	
	        if (!scope && array) {
	            params.add(value.name, value.value);
	        } else if (hash) {
	            serialize(params, value, key);
	        } else {
	            params.add(key, value);
	        }
	    });
	}
	
	/**
	 * XDomain client (Internet Explorer).
	 */
	
	function xdrClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xdr = new XDomainRequest(),
	            handler = function (_ref) {
	            var type = _ref.type;
	
	
	            var status = 0;
	
	            if (type === 'load') {
	                status = 200;
	            } else if (type === 'error') {
	                status = 500;
	            }
	
	            resolve(request.respondWith(xdr.responseText, { status: status }));
	        };
	
	        request.abort = function () {
	            return xdr.abort();
	        };
	
	        xdr.open(request.method, request.getUrl());
	        xdr.timeout = 0;
	        xdr.onload = handler;
	        xdr.onerror = handler;
	        xdr.ontimeout = handler;
	        xdr.onprogress = function () {};
	        xdr.send(request.getBody());
	    });
	}
	
	/**
	 * CORS Interceptor.
	 */
	
	var ORIGIN_URL = Url.parse(location.href);
	var SUPPORTS_CORS = 'withCredentials' in new XMLHttpRequest();
	
	function cors (request, next) {
	
	    if (!isBoolean(request.crossOrigin) && crossOrigin(request)) {
	        request.crossOrigin = true;
	    }
	
	    if (request.crossOrigin) {
	
	        if (!SUPPORTS_CORS) {
	            request.client = xdrClient;
	        }
	
	        delete request.emulateHTTP;
	    }
	
	    next();
	}
	
	function crossOrigin(request) {
	
	    var requestUrl = Url.parse(Url(request));
	
	    return requestUrl.protocol !== ORIGIN_URL.protocol || requestUrl.host !== ORIGIN_URL.host;
	}
	
	/**
	 * Body Interceptor.
	 */
	
	function body (request, next) {
	
	    if (isFormData(request.body)) {
	
	        request.headers.delete('Content-Type');
	    } else if (isObject(request.body) || isArray(request.body)) {
	
	        if (request.emulateJSON) {
	            request.body = Url.params(request.body);
	            request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
	        } else {
	            request.body = JSON.stringify(request.body);
	        }
	    }
	
	    next(function (response) {
	
	        Object.defineProperty(response, 'data', {
	            get: function () {
	                return this.body;
	            },
	            set: function (body) {
	                this.body = body;
	            }
	        });
	
	        return response.bodyText ? when(response.text(), function (text) {
	
	            var type = response.headers.get('Content-Type');
	
	            if (isString(type) && type.indexOf('application/json') === 0) {
	
	                try {
	                    response.body = JSON.parse(text);
	                } catch (e) {
	                    response.body = null;
	                }
	            } else {
	                response.body = text;
	            }
	
	            return response;
	        }) : response;
	    });
	}
	
	/**
	 * JSONP client.
	 */
	
	function jsonpClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var name = request.jsonp || 'callback',
	            callback = '_jsonp' + Math.random().toString(36).substr(2),
	            body = null,
	            handler,
	            script;
	
	        handler = function (_ref) {
	            var type = _ref.type;
	
	
	            var status = 0;
	
	            if (type === 'load' && body !== null) {
	                status = 200;
	            } else if (type === 'error') {
	                status = 500;
	            }
	
	            resolve(request.respondWith(body, { status: status }));
	
	            delete window[callback];
	            document.body.removeChild(script);
	        };
	
	        request.params[name] = callback;
	
	        window[callback] = function (result) {
	            body = JSON.stringify(result);
	        };
	
	        script = document.createElement('script');
	        script.src = request.getUrl();
	        script.type = 'text/javascript';
	        script.async = true;
	        script.onload = handler;
	        script.onerror = handler;
	
	        document.body.appendChild(script);
	    });
	}
	
	/**
	 * JSONP Interceptor.
	 */
	
	function jsonp (request, next) {
	
	    if (request.method == 'JSONP') {
	        request.client = jsonpClient;
	    }
	
	    next(function (response) {
	
	        if (request.method == 'JSONP') {
	
	            return when(response.json(), function (json) {
	
	                response.body = json;
	
	                return response;
	            });
	        }
	    });
	}
	
	/**
	 * Before Interceptor.
	 */
	
	function before (request, next) {
	
	    if (isFunction(request.before)) {
	        request.before.call(this, request);
	    }
	
	    next();
	}
	
	/**
	 * HTTP method override Interceptor.
	 */
	
	function method (request, next) {
	
	    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
	        request.headers.set('X-HTTP-Method-Override', request.method);
	        request.method = 'POST';
	    }
	
	    next();
	}
	
	/**
	 * Header Interceptor.
	 */
	
	function header (request, next) {
	
	    var headers = assign({}, Http.headers.common, !request.crossOrigin ? Http.headers.custom : {}, Http.headers[toLower(request.method)]);
	
	    each(headers, function (value, name) {
	        if (!request.headers.has(name)) {
	            request.headers.set(name, value);
	        }
	    });
	
	    next();
	}
	
	/**
	 * Timeout Interceptor.
	 */
	
	function timeout (request, next) {
	
	    var timeout;
	
	    if (request.timeout) {
	        timeout = setTimeout(function () {
	            request.abort();
	        }, request.timeout);
	    }
	
	    next(function (response) {
	
	        clearTimeout(timeout);
	    });
	}
	
	/**
	 * XMLHttp client.
	 */
	
	function xhrClient (request) {
	    return new PromiseObj(function (resolve) {
	
	        var xhr = new XMLHttpRequest(),
	            handler = function (event) {
	
	            var response = request.respondWith('response' in xhr ? xhr.response : xhr.responseText, {
	                status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
	                statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
	            });
	
	            each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
	                response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
	            });
	
	            resolve(response);
	        };
	
	        request.abort = function () {
	            return xhr.abort();
	        };
	
	        if (request.progress) {
	            if (request.method === 'GET') {
	                xhr.addEventListener('progress', request.progress);
	            } else if (/^(POST|PUT)$/i.test(request.method)) {
	                xhr.upload.addEventListener('progress', request.progress);
	            }
	        }
	
	        xhr.open(request.method, request.getUrl(), true);
	
	        if ('responseType' in xhr) {
	            xhr.responseType = 'blob';
	        }
	
	        if (request.credentials === true) {
	            xhr.withCredentials = true;
	        }
	
	        request.headers.forEach(function (value, name) {
	            xhr.setRequestHeader(name, value);
	        });
	
	        xhr.timeout = 0;
	        xhr.onload = handler;
	        xhr.onerror = handler;
	        xhr.send(request.getBody());
	    });
	}
	
	/**
	 * Base client.
	 */
	
	function Client (context) {
	
	    var reqHandlers = [sendRequest],
	        resHandlers = [],
	        handler;
	
	    if (!isObject(context)) {
	        context = null;
	    }
	
	    function Client(request) {
	        return new PromiseObj(function (resolve) {
	
	            function exec() {
	
	                handler = reqHandlers.pop();
	
	                if (isFunction(handler)) {
	                    handler.call(context, request, next);
	                } else {
	                    warn('Invalid interceptor of type ' + typeof handler + ', must be a function');
	                    next();
	                }
	            }
	
	            function next(response) {
	
	                if (isFunction(response)) {
	
	                    resHandlers.unshift(response);
	                } else if (isObject(response)) {
	
	                    resHandlers.forEach(function (handler) {
	                        response = when(response, function (response) {
	                            return handler.call(context, response) || response;
	                        });
	                    });
	
	                    when(response, resolve);
	
	                    return;
	                }
	
	                exec();
	            }
	
	            exec();
	        }, context);
	    }
	
	    Client.use = function (handler) {
	        reqHandlers.push(handler);
	    };
	
	    return Client;
	}
	
	function sendRequest(request, resolve) {
	
	    var client = request.client || xhrClient;
	
	    resolve(client(request));
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	/**
	 * HTTP Headers.
	 */
	
	var Headers = function () {
	    function Headers(headers) {
	        var _this = this;
	
	        classCallCheck(this, Headers);
	
	
	        this.map = {};
	
	        each(headers, function (value, name) {
	            return _this.append(name, value);
	        });
	    }
	
	    Headers.prototype.has = function has(name) {
	        return getName(this.map, name) !== null;
	    };
	
	    Headers.prototype.get = function get(name) {
	
	        var list = this.map[getName(this.map, name)];
	
	        return list ? list[0] : null;
	    };
	
	    Headers.prototype.getAll = function getAll(name) {
	        return this.map[getName(this.map, name)] || [];
	    };
	
	    Headers.prototype.set = function set(name, value) {
	        this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
	    };
	
	    Headers.prototype.append = function append(name, value) {
	
	        var list = this.getAll(name);
	
	        if (list.length) {
	            list.push(trim(value));
	        } else {
	            this.set(name, value);
	        }
	    };
	
	    Headers.prototype.delete = function _delete(name) {
	        delete this.map[getName(this.map, name)];
	    };
	
	    Headers.prototype.forEach = function forEach(callback, thisArg) {
	        var _this2 = this;
	
	        each(this.map, function (list, name) {
	            each(list, function (value) {
	                return callback.call(thisArg, value, name, _this2);
	            });
	        });
	    };
	
	    return Headers;
	}();
	
	function getName(map, name) {
	    return Object.keys(map).reduce(function (prev, curr) {
	        return toLower(name) === toLower(curr) ? curr : prev;
	    }, null);
	}
	
	function normalizeName(name) {
	
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	        throw new TypeError('Invalid character in header field name');
	    }
	
	    return trim(name);
	}
	
	/**
	 * HTTP Response.
	 */
	
	var Response = function () {
	    function Response(body, _ref) {
	        var url = _ref.url;
	        var headers = _ref.headers;
	        var status = _ref.status;
	        var statusText = _ref.statusText;
	        classCallCheck(this, Response);
	
	
	        this.url = url;
	        this.ok = status >= 200 && status < 300;
	        this.status = status || 0;
	        this.statusText = statusText || '';
	        this.headers = new Headers(headers);
	        this.body = body;
	
	        if (isString(body)) {
	
	            this.bodyText = body;
	        } else if (isBlob(body)) {
	
	            this.bodyBlob = body;
	
	            if (isBlobText(body)) {
	                this.bodyText = blobText(body);
	            }
	        }
	    }
	
	    Response.prototype.blob = function blob() {
	        return when(this.bodyBlob);
	    };
	
	    Response.prototype.text = function text() {
	        return when(this.bodyText);
	    };
	
	    Response.prototype.json = function json() {
	        return when(this.text(), function (text) {
	            return JSON.parse(text);
	        });
	    };
	
	    return Response;
	}();
	
	function blobText(body) {
	    return new PromiseObj(function (resolve) {
	
	        var reader = new FileReader();
	
	        reader.readAsText(body);
	        reader.onload = function () {
	            resolve(reader.result);
	        };
	    });
	}
	
	function isBlobText(body) {
	    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
	}
	
	/**
	 * HTTP Request.
	 */
	
	var Request = function () {
	    function Request(options) {
	        classCallCheck(this, Request);
	
	
	        this.body = null;
	        this.params = {};
	
	        assign(this, options, {
	            method: toUpper(options.method || 'GET')
	        });
	
	        if (!(this.headers instanceof Headers)) {
	            this.headers = new Headers(this.headers);
	        }
	    }
	
	    Request.prototype.getUrl = function getUrl() {
	        return Url(this);
	    };
	
	    Request.prototype.getBody = function getBody() {
	        return this.body;
	    };
	
	    Request.prototype.respondWith = function respondWith(body, options) {
	        return new Response(body, assign(options || {}, { url: this.getUrl() }));
	    };
	
	    return Request;
	}();
	
	/**
	 * Service for sending network requests.
	 */
	
	var CUSTOM_HEADERS = { 'X-Requested-With': 'XMLHttpRequest' };
	var COMMON_HEADERS = { 'Accept': 'application/json, text/plain, */*' };
	var JSON_CONTENT_TYPE = { 'Content-Type': 'application/json;charset=utf-8' };
	
	function Http(options) {
	
	    var self = this || {},
	        client = Client(self.$vm);
	
	    defaults(options || {}, self.$options, Http.options);
	
	    Http.interceptors.forEach(function (handler) {
	        client.use(handler);
	    });
	
	    return client(new Request(options)).then(function (response) {
	
	        return response.ok ? response : PromiseObj.reject(response);
	    }, function (response) {
	
	        if (response instanceof Error) {
	            error(response);
	        }
	
	        return PromiseObj.reject(response);
	    });
	}
	
	Http.options = {};
	
	Http.headers = {
	    put: JSON_CONTENT_TYPE,
	    post: JSON_CONTENT_TYPE,
	    patch: JSON_CONTENT_TYPE,
	    delete: JSON_CONTENT_TYPE,
	    custom: CUSTOM_HEADERS,
	    common: COMMON_HEADERS
	};
	
	Http.interceptors = [before, timeout, method, body, jsonp, header, cors];
	
	['get', 'delete', 'head', 'jsonp'].forEach(function (method) {
	
	    Http[method] = function (url, options) {
	        return this(assign(options || {}, { url: url, method: method }));
	    };
	});
	
	['post', 'put', 'patch'].forEach(function (method) {
	
	    Http[method] = function (url, body, options) {
	        return this(assign(options || {}, { url: url, method: method, body: body }));
	    };
	});
	
	/**
	 * Service for interacting with RESTful services.
	 */
	
	function Resource(url, params, actions, options) {
	
	    var self = this || {},
	        resource = {};
	
	    actions = assign({}, Resource.actions, actions);
	
	    each(actions, function (action, name) {
	
	        action = merge({ url: url, params: assign({}, params) }, options, action);
	
	        resource[name] = function () {
	            return (self.$http || Http)(opts(action, arguments));
	        };
	    });
	
	    return resource;
	}
	
	function opts(action, args) {
	
	    var options = assign({}, action),
	        params = {},
	        body;
	
	    switch (args.length) {
	
	        case 2:
	
	            params = args[0];
	            body = args[1];
	
	            break;
	
	        case 1:
	
	            if (/^(POST|PUT|PATCH)$/i.test(options.method)) {
	                body = args[0];
	            } else {
	                params = args[0];
	            }
	
	            break;
	
	        case 0:
	
	            break;
	
	        default:
	
	            throw 'Expected up to 4 arguments [params, body], got ' + args.length + ' arguments';
	    }
	
	    options.body = body;
	    options.params = assign({}, options.params, params);
	
	    return options;
	}
	
	Resource.actions = {
	
	    get: { method: 'GET' },
	    save: { method: 'POST' },
	    query: { method: 'GET' },
	    update: { method: 'PUT' },
	    remove: { method: 'DELETE' },
	    delete: { method: 'DELETE' }
	
	};
	
	/**
	 * Install plugin.
	 */
	
	function plugin(Vue) {
	
	    if (plugin.installed) {
	        return;
	    }
	
	    Util(Vue);
	
	    Vue.url = Url;
	    Vue.http = Http;
	    Vue.resource = Resource;
	    Vue.Promise = PromiseObj;
	
	    Object.defineProperties(Vue.prototype, {
	
	        $url: {
	            get: function () {
	                return options(Vue.url, this, this.$options.url);
	            }
	        },
	
	        $http: {
	            get: function () {
	                return options(Vue.http, this, this.$options.http);
	            }
	        },
	
	        $resource: {
	            get: function () {
	                return Vue.resource.bind(this);
	            }
	        },
	
	        $promise: {
	            get: function () {
	                var _this = this;
	
	                return function (executor) {
	                    return new Vue.Promise(executor, _this);
	                };
	            }
	        }
	
	    });
	}
	
	if (typeof window !== 'undefined' && window.Vue) {
	    window.Vue.use(plugin);
	}
	
	module.exports = plugin;

/***/ },
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(14);
	var global        = __webpack_require__(25)
	  , hide          = __webpack_require__(29)
	  , Iterators     = __webpack_require__(17)
	  , TO_STRING_TAG = __webpack_require__(56)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(15)
	  , step             = __webpack_require__(16)
	  , Iterators        = __webpack_require__(17)
	  , toIObject        = __webpack_require__(18);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(22)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 15 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(19)
	  , defined = __webpack_require__(21);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(20);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 20 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 21 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(23)
	  , $export        = __webpack_require__(24)
	  , redefine       = __webpack_require__(39)
	  , hide           = __webpack_require__(29)
	  , has            = __webpack_require__(40)
	  , Iterators      = __webpack_require__(17)
	  , $iterCreate    = __webpack_require__(41)
	  , setToStringTag = __webpack_require__(55)
	  , getPrototypeOf = __webpack_require__(57)
	  , ITERATOR       = __webpack_require__(56)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 23 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(25)
	  , core      = __webpack_require__(26)
	  , ctx       = __webpack_require__(27)
	  , hide      = __webpack_require__(29)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 25 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 26 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(28);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(30)
	  , createDesc = __webpack_require__(38);
	module.exports = __webpack_require__(34) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(31)
	  , IE8_DOM_DEFINE = __webpack_require__(33)
	  , toPrimitive    = __webpack_require__(37)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(34) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(34) && !__webpack_require__(35)(function(){
	  return Object.defineProperty(__webpack_require__(36)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(35)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 35 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(32)
	  , document = __webpack_require__(25).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(32);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 38 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(29);

/***/ },
/* 40 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(42)
	  , descriptor     = __webpack_require__(38)
	  , setToStringTag = __webpack_require__(55)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(29)(IteratorPrototype, __webpack_require__(56)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(31)
	  , dPs         = __webpack_require__(43)
	  , enumBugKeys = __webpack_require__(53)
	  , IE_PROTO    = __webpack_require__(50)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(36)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(54).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(30)
	  , anObject = __webpack_require__(31)
	  , getKeys  = __webpack_require__(44);
	
	module.exports = __webpack_require__(34) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(45)
	  , enumBugKeys = __webpack_require__(53);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(40)
	  , toIObject    = __webpack_require__(18)
	  , arrayIndexOf = __webpack_require__(46)(false)
	  , IE_PROTO     = __webpack_require__(50)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(18)
	  , toLength  = __webpack_require__(47)
	  , toIndex   = __webpack_require__(49);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(48)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 48 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(48)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(51)('keys')
	  , uid    = __webpack_require__(52);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 52 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 53 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(25).document && document.documentElement;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(30).f
	  , has = __webpack_require__(40)
	  , TAG = __webpack_require__(56)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(51)('wks')
	  , uid        = __webpack_require__(52)
	  , Symbol     = __webpack_require__(25).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(40)
	  , toObject    = __webpack_require__(58)
	  , IE_PROTO    = __webpack_require__(50)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(21);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(60)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(22)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(48)
	  , defined   = __webpack_require__(21);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 61 */,
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(63)
	  , ITERATOR  = __webpack_require__(56)('iterator')
	  , Iterators = __webpack_require__(17);
	module.exports = __webpack_require__(26).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(20)
	  , TAG = __webpack_require__(56)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 64 */,
/* 65 */,
/* 66 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(69)
	
	/* script */
	__vue_exports__ = __webpack_require__(72)
	
	/* template */
	var __vue_template__ = __webpack_require__(73)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(70);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(71)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2ecc083c!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./error.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2ecc083c!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./error.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(66)();
	// imports
	
	
	// module
	exports.push([module.id, ".vm-vap-error{margin-top:5.3rem}.vm-vap-error .vm-vap-error-img{height:2.15rem;width:2.3rem;background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAK8AAAChCAMAAACGRh83AAAA5FBMVEUAAACurq6vr6+rq6urq6usrKyrq6uxsbGxsbG1tbWwsLCqqqqvr6+qqqqqqqqqqqqrq6uqqqqsrKyurq6rq6uxsbGrq6urq6urq6uqqqqrq6uzs7Orq6urq6u1tbWrq6usrKyrq6usrKyurq6rq6urq6uurq6rq6urq6urq6urq6urq6urq6usrKysrKyrq6uurq6rq6utra2tra2qqqqrq6urq6urq6urq6uqqqqrq6uurq6rq6uqqqr19fXx8fHt7e2wsLDl5eXc3NzV1dW6urq1tbXo6Ojg4ODOzs7Hx8fAwMDU+QAdAAAAPXRSTlMAJiJYzJ+FHg0EFPgZ/Om1qfEyKo8QpfTc4a8I5WEKclRwZihrSC6Xkn9A7XhdT8JEiEw41Me8m4zYnjzQkXO/TgAACjtJREFUeNrVnOlW6joYhhNAoJQyzzKJDDKDgODw4nY6+2y9//s5TE1wI7UhHTzPr7iWa/mahi9P+tESaxgVchpMExnWz4mLhIcQJdIgrjGJIFKhisD/V/VB6xGXSHYRDRJBehrqxBVCeWQUIowXmjtLIoPZSR+eNopp4jzXyAbISQwxJ84zRYWcxqWqUeI0A+Q/L16lHDTLHHfEaYa4+JQ2TM0z0tRJSCFOEkC2TDhBKsQN2jTgaOAKYoSTpmJcwEcpdTLwEFXCKFNBmiomlHqcC6xkkeY/eKgoM9QopWHiFE3k9qyACjPHFV0RJA5Rwxkbn1Nx6hjSFR7iEFeoyEwvHaFInZzgG1yz1UtPIKmiSVcEiDPk4WGaRsWp3qkYbEbOHDfONU1hO4dw2HkRKyp0TYg4QRPTE5fDYBO2eFfAFXVuQXhROGUnHrTyACJnXkoriNIVDm1ybfiFl+/1NmzGu10UmNINZeIAGZTY8hUMuyOB7HbgyFHDh4k+9JgIe5XbhO1fUk4EHUqd2pO5PSj0GxqbsF0WlhtEybEPXAARpmZmwsZKLCwjAz91akseYWjCfBupWxb2ED8yjhWIOlrflYfRJmw8VkrSrylhRoV3OHnbCX8ZdjFdhy3UkvQoHUQcKxA3aLDyIBaWc6mi6dSOXOS28/esjR94WGNuMXCooJ1DVfThYdgsC2tMFBWHCkQC00N7uPdvwkbrSWqO1s54KLEbLz/Lh/Swvm3YJjWJhPHI2E5YNCxngFvqzJkohj7b6e7b67Bq9EIgLDceZwrEg2474fpMA9QbgbBOGw+3nVDtZhO2IhDWFeMJoKiHjVYSVAB3jKeB223YfjBNBXDLeDLYhE0Ln+UPjceRI1EM01La9K0d943nk+0Y8yOMp4gAsx0ppqg6UNDK+7ZzlJ9jPAk8cNuR4gotB4ynv287MnDjOT86N7GiWowliAz+fduRYoCcofEobRVr1LYiVc68/N6OFE2ol0YFog1tnAgmxhraUn1Ydn2oHJddRA0KRELVOptBR1MlloQK/fIpUmH7mS6gJY4bTwzj3WiMGDkVD4qssp0e1puJAIhjblAgikiwklSUsJ0bfZiWCptvDdqIMeMxupBBqBKN2CupcuY924XdGI+PGY9d89tC/fTyUL3bhJ0PdsdUdJnx2LV+hxhx2xEMu2ldzKuUkUWCFTSb6kPkNNup7vosVQHjkaq/h0v/XLQpdOY9NJ4eMx579rcJfCy6YFNI1Hi4PzhnO7zP8iUXuLH5JrCfr6Ww6bCXR3+DG49NFMzaDm8KSRiPPFM09aGJPgsLe4wiRrYeiRQVZX0o3hQ6ZIiarfd4PMgz2xFvCh1yhrGtR6JrQ9sZLVhTyCQHxmNMuh2Qtx3jPosxfWY8At8LEGC+ZztyYQ+MxwxhTU1L2I5gU4hjYDzGRFEXtB1WeQyaQgI8wCtSILyYbS+ut2xqvSPLbWe/KdSkJ1JgxmOKchweEizdaKiI2o5Bn0WAFOZCBe0MmUwWUGOmdpgSMvrK77GwUtTFjCcRw4phyeSnboz2ts8y1ISbQvLGE+hNsaIVELCdqiVhOU1NTZorEPRGAyJXZ2gR09zCv2ldFLxBahF5NMwZTxtq7FohSXQVYpKqhnXYfpDZjjxD1M0VtHJju2h9qBKTLIBoP8hsxxLusBAznor5PbkkcG9H3njk9+QeUhK3fuWMhxNFg5jjDjVuOxYx4cZjksCF2UsxQ4fbjlXEMREwntNsR7w8iBuPPKF92xFE3Hjkud+3HctY4M6mI1wJZ/wwZBXNlm33eMboWVzOkrVCFsjbdI8nynfCgDVh4wCmmsaMx1pySOpDy8IuOgbGI4eiaef6UDJsKbYOe7sY0RU3zHiECaV8cV/qyIVJIsdcyYKwqdEn45nU6sILohPBmkjnyBObUW478mEZPRQo9WcBtSI4uxFEE8FEFJHQ17azkCsPl/1YF0DuqkH38eKBZoCPD2BBREjtJjCKlLW2w/uvPCxngngBeFkuX4AeEcCHxK495/vadu6Z7ZwYtnX9tfHg6d/lihcI3b6JI7jrAcXJF3S57Qj3X3nYQxJxPD0vN7xC81o1vyHEme2c1H89wuQBT7+XO16hXlu0fu8xY7YjGHY+oEe5z+GfX5vF8Lqe5D9Q762pDzUx2+HN4io1YFTcxV2+4c9yxTviCUvq78KU7fCwrP9qxHUEb49LlncbOEKt2N+iGLByJtAsNsQbx8fjUs/7uh18IB9w0HYGc9Z//Y5Slsdd/qPnfXzDbcgK21H0oUCz2Ii6ivcl42mVlwX2pYko4rbDm8Wm6GmbFcvzvujDX/9gKHvaqB6xHR6W9V/NMcY6LgfrvDxwVCECCNiOwUN5RrSgX3+W998l4/cTYnKBzw4f2TRuFhuT2U4n53Gdl/P8JHCfV8B2hPqvHD9Px/M+L/cDA2MiQRwhXh4OH8oTI6nqcRm/gN/Lff4FGuRkwugy2zm1WcwZ4G15NC93Hx85mQ63nfSp/VdOB0+Py8/8Bn79vUJUmRdU3LFNuzNmYU9lqu8UjOeDvM/Ik5NJ6bYTqLBmsQQDFX8O8upTzmqwX+bezmATdsYeypOjpuH174/XdsAr8EyRsR26DRuPsZamFBUWmOf9XH+HQakXVGxmNlY9V6g1tD/vGL9eXvbTPyF6Lvf+mnXYspW3fhdszzjgBcgocrZTaJRZObOI+fpczHh+3I97RaRoY8xtxzJieyfjNz5+Bfw2vKBCnssoC/kLTC//ABVbXlAhT3Kon46X/+i+8wdayaYXVMjT9OmBH1+3cd+hVoksYUS47VhK4pYd6DepP5AdEWk6Bi+okGSSXwfmcbsTIk8dc4s7WZxOBB/6nvGGSMLmF1TI0+jiXTec/Cht8eu4PNRyqlm8b+Pm7q3pauVB9SG1gb6K998vT3iYnN7VCnW8FzoVaBV96LeDmIoVufFq2F79kVKDCupYfajBVXKLADGNNw+ow8xVasdVJqYPW2c2UYhmtoPVX72LFgF1bFIolRTgq5aP7BzUbraWPskAs7BJt1Fr5BgBajd6QUvkkDdTLHqIG2wx1HbYpIZmGH4v7U3N6HXNCrWdAC9ReeP+IWsOHadMbcezry3x71YENf6VNLUfZX/yet+u3ru/SnEoHOB4qP0EOCX4lO9MYfDp+geomzRVJMKGiXPwHLzk2UVucW38TcUsyjxugLrNECVq6EBx8P/G/bh0hr7xV6emSPKThPvk0DD+Ll0UfbY1uM9EU5vG352qofCDpreHIaWGExzWNKoffNxnih795iVeLRR+zHLooZhkVnGEcByV7X0R17nOosKt4hgDaDVmNm4yiKBAGUYKgXnI9fm9bGcxS+5Z23H6KuLjCXWT+3YOiCX3rdiAZBRANudzi9sugHyd7vGNB09SebhJPHrBJtfk0yTpkdctrieHh6TvcV0mzU3vT9JJvnrNoPyELZkd8f8/Mxwipkm7P8WBMhGhHA54XCMQDuki+R+1zpRiGM022wAAAABJRU5ErkJggg==) 50%/cover no-repeat;margin:0 auto}.vm-vap-error .vm-vap-error-msg{margin-top:.585rem;font-size:14px;line-height:1;color:#9e9e9e;text-align:center}.vm-vap-error .vm-vap-error-btn{height:30px;width:100px;margin:.56rem auto 0;text-align:center;font-size:0;border:1px solid #e0e0e0;border-radius:5px;cursor:pointer}.vm-vap-error .vm-vap-error-btn .btn-text{display:inline-block;height:30px;line-height:30px;font-size:12px;color:#757575;padding-left:20px;background:url(data:image/gif;base64,R0lGODlhgACAAKIAAP///93d3bu7u5mZmQAA/wAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBQAEACwCAAIAfAB8AAAD/0i63P4wygYqmDjrzbtflvWNZGliYXiubKuloivPLlzReD7al+7/Eh5wSFQIi8hHYBkwHUmD6CD5YTJLz49USuVYraRsZ7vtar7XnQ1Kjpoz6LRHvGlz35O4nEPP2O94EnpNc2sef1OBGIOFMId/inB6jSmPdpGScR19EoiYmZobnBCIiZ95k6KGGp6ni4wvqxilrqBfqo6skLW2YBmjDa28r6Eosp27w8Rov8ekycqoqUHODrTRvXsQwArC2NLF29UM19/LtxO5yJd4Au4CK7DUNxPebG4e7+8n8iv2WmQ66BtoYpo/dvfacBjIkITBE9DGlMvAsOIIZjIUAixliv9ixYZVtLUos5GjwI8gzc3iCGghypQqrbFsme8lwZgLZtIcYfNmTJ34WPTUZw5oRxdD9w0z6iOpO15MgTh1BTTJUKos39jE+o/KS64IFVmsFfYT0aU7capdy7at27dw48qdS7eu3bt480I02vUbX2F/JxYNDImw4GiGE/P9qbhxVpWOI/eFKtlNZbWXuzlmG1mv58+gQ4seTbq06dOoU6vGQZJy0FNlMcV+czhQ7SQmYd8eMhPs5BxVdfcGEtV3buDBXQ+fURxx8oM6MT9P+Fh6dOrH2zavc13u9JXVJb520Vp8dvC76wXMuN5Sepm/1WtkEZHDefnzR9Qvsd9+/wi8+en3X0ntYVcSdAE+UN4zs7ln24CaLagghIxBaGF8kFGoIYV+Ybghh841GIyI5ICIFoklJsigihmimJOLEbLYIYwxSgigiZ+8l2KB+Ml4oo/w8dijjcrouCORKwIpnJIjMnkkksalNeR4fuBIm5UEYImhIlsGCeWNNJphpJdSTlkml1jWeOY6TnaRpppUctcmFW9mGSaZceYopH9zkjnjUe59iR5pdapWaGqHopboaYua1qije67GJ6CuJAAAIfkEBQUABAAsCgACAFcAMAAAA/9Iutz+ML5Ag7w46z0r5WAoSp43nihXVmnrdusrv+s332dt4Tyo9yOBUJD6oQBIQGs4RBlHySSKyczVTtHoidocPUNZaZAr9F5FYbGI3PWdQWn1mi36buLKFJvojsHjLnshdhl4L4IqbxqGh4gahBJ4eY1kiX6LgDN7fBmQEJI4jhieD4yhdJ2KkZk8oiSqEaatqBekDLKztBG2CqBACq4wJRi4PZu1sA2+v8C6EJexrBAD1AOBzsLE0g/V1UvYR9sN3eR6lTLi4+TlY1wz6Qzr8u1t6FkY8vNzZTxaGfn6mAkEGFDgL4LrDDJDyE4hEIbdHB6ESE1iD4oVLfLAqPETIsOODwmCDJlv5MSGJklaS6khAQAh+QQFBQAEACwfAAIAVwAwAAAD/0i63P5LSAGrvTjrNuf+YKh1nWieIumhbFupkivPBEzR+GnnfLj3ooFwwPqdAshAazhEGUXJJIrJ1MGOUamJ2jQ9QVltkCv0XqFh5IncBX01afGYnDqD40u2z76JK/N0bnxweC5sRB9vF34zh4gjg4uMjXobihWTlJUZlw9+fzSHlpGYhTminKSepqebF50NmTyor6qxrLO0L7YLn0ALuhCwCrJAjrUqkrjGrsIkGMW/BMEPJcphLgDaABjUKNEh29vdgTLLIOLpF80s5xrp8ORVONgi8PcZ8zlRJvf40tL8/QPYQ+BAgjgMxkPIQ6E6hgkdjoNIQ+JEijMsasNY0RQix4gKP+YIKXKkwJIFF6JMudFEAgAh+QQFBQAEACw8AAIAQgBCAAAD/kg0PPowykmrna3dzXvNmSeOFqiRaGoyaTuujitv8Gx/661HtSv8gt2jlwIChYtc0XjcEUnMpu4pikpv1I71astytkGh9wJGJk3QrXlcKa+VWjeSPZHP4Rtw+I2OW81DeBZ2fCB+UYCBfWRqiQp0CnqOj4J1jZOQkpOUIYx/m4oxg5cuAaYBO4Qop6c6pKusrDevIrG2rkwptrupXB67vKAbwMHCFcTFxhLIt8oUzLHOE9Cy0hHUrdbX2KjaENzey9Dh08jkz8Tnx83q66bt8PHy8/T19vf4+fr6AP3+/wADAjQmsKDBf6AOKjS4aaHDgZMeSgTQcKLDhBYPEswoA1BBAgAh+QQFBQAEACxOAAoAMABXAAAD7Ei6vPOjyUkrhdDqfXHm4OZ9YSmNpKmiqVqykbuysgvX5o2HcLxzup8oKLQQix0UcqhcVo5ORi+aHFEn02sDeuWqBGCBkbYLh5/NmnldxajX7LbPBK+PH7K6narfO/t+SIBwfINmUYaHf4lghYyOhlqJWgqDlAuAlwyBmpVnnaChoqOkpaanqKmqKgGtrq+wsbA1srW2ry63urasu764Jr/CAb3Du7nGt7TJsqvOz9DR0tPU1TIA2ACl2dyi3N/aneDf4uPklObj6OngWuzt7u/d8fLY9PXr9eFX+vv8+PnYlUsXiqC3c6PmUUgAACH5BAUFAAQALE4AHwAwAFcAAAPpSLrc/m7IAau9bU7MO9GgJ0ZgOI5leoqpumKt+1axPJO1dtO5vuM9yi8TlAyBvSMxqES2mo8cFFKb8kzWqzDL7Xq/4LB4TC6bz1yBes1uu9uzt3zOXtHv8xN+Dx/x/wJ6gHt2g3Rxhm9oi4yNjo+QkZKTCgGWAWaXmmOanZhgnp2goaJdpKGmp55cqqusrZuvsJays6mzn1m4uRAAvgAvuBW/v8GwvcTFxqfIycA3zA/OytCl0tPPO7HD2GLYvt7dYd/ZX99j5+Pi6tPh6+bvXuTuzujxXens9fr7YPn+7egRI9PPHrgpCQAAIfkEBQUABAAsPAA8AEIAQgAAA/lIutz+UI1Jq7026h2x/xUncmD5jehjrlnqSmz8vrE8u7V5z/m5/8CgcEgsGo/IpHLJbDqf0Kh0ShBYBdTXdZsdbb/Yrgb8FUfIYLMDTVYz2G13FV6Wz+lX+x0fdvPzdn9WeoJGAYcBN39EiIiKeEONjTt0kZKHQGyWl4mZdREAoQAcnJhBXBqioqSlT6qqG6WmTK+rsa1NtaGsuEu6o7yXubojsrTEIsa+yMm9SL8osp3PzM2cStDRykfZ2tfUtS/bRd3ewtzV5pLo4eLjQuUp70Hx8t9E9eqO5Oku5/ztdkxi90qPg3x2EMpR6IahGocPCxp8AGtigwQAIfkEBQUABAAsHwBOAFcAMAAAA/9Iutz+MMo36pg4682J/V0ojs1nXmSqSqe5vrDXunEdzq2ta3i+/5DeCUh0CGnF5BGULC4tTeUTFQVONYAs4CfoCkZPjFar83rBx8l4XDObSUL1Ott2d1U4yZwcs5/xSBB7dBMBhgEYfncrTBGDW4WHhomKUY+QEZKSE4qLRY8YmoeUfkmXoaKInJ2fgxmpqqulQKCvqRqsP7WooriVO7u8mhu5NacasMTFMMHCm8qzzM2RvdDRK9PUwxzLKdnaz9y/Kt8SyR3dIuXmtyHpHMcd5+jvWK4i8/TXHff47SLjQvQLkU+fG29rUhQ06IkEG4X/Rryp4mwUxSgLL/7IqFETB8eONT6ChCFy5ItqJomES6kgAQAh+QQFBQAEACwKAE4AVwAwAAAD/0i63A4QuEmrvTi3yLX/4MeNUmieITmibEuppCu3sDrfYG3jPKbHveDktxIaF8TOcZmMLI9NyBPanFKJp4A2IBx4B5lkdqvtfb8+HYpMxp3Pl1qLvXW/vWkli16/3dFxTi58ZRcChwIYf3hWBIRchoiHiotWj5AVkpIXi4xLjxiaiJR/T5ehoomcnZ+EGamqq6VGoK+pGqxCtaiiuJVBu7yaHrk4pxqwxMUzwcKbyrPMzZG90NGDrh/JH8t72dq3IN1jfCHb3L/e5ebh4ukmxyDn6O8g08jt7tf26ybz+m/W9GNXzUQ9fm1Q/APoSWAhhfkMAmpEbRhFKwsvCsmosRIHx444PoKcIXKkjIImjTzjkQAAIfkEBQUABAAsAgA8AEIAQgAAA/VIBNz+8KlJq72Yxs1d/uDVjVxogmQqnaylvkArT7A63/V47/m2/8CgcEgsGo/IpHLJbDqf0Kh0Sj0FroGqDMvVmrjgrDcTBo8v5fCZki6vCW33Oq4+0832O/at3+f7fICBdzsChgJGeoWHhkV0P4yMRG1BkYeOeECWl5hXQ5uNIAOjA1KgiKKko1CnqBmqqk+nIbCkTq20taVNs7m1vKAnurtLvb6wTMbHsUq4wrrFwSzDzcrLtknW16tI2tvERt6pv0fi48jh5h/U6Zs77EXSN/BE8jP09ZFA+PmhP/xvJgAMSGBgQINvEK5ReIZhQ3QEMTBLAAAh+QQFBQAEACwCAB8AMABXAAAD50i6DA4syklre87qTbHn4OaNYSmNqKmiqVqyrcvBsazRpH3jmC7yD98OCBF2iEXjBKmsAJsWHDQKmw571l8my+16v+CweEwum8+hgHrNbrvbtrd8znbR73MVfg838f8BeoB7doN0cYZvaIuMjY6PkJGSk2gClgJml5pjmp2YYJ6dX6GeXaShWaeoVqqlU62ir7CXqbOWrLafsrNctjIDwAMWvC7BwRWtNsbGFKc+y8fNsTrQ0dK3QtXAYtrCYd3eYN3c49/a5NVj5eLn5u3s6e7x8NDo9fbL+Mzy9/T5+tvUzdN3Zp+GBAAh+QQJBQAEACwCAAIAfAB8AAAD/0i63P4wykmrvTjrzbv/YCiOZGmeaKqubOu+cCzPdArcQK2TOL7/nl4PSMwIfcUk5YhUOh3M5nNKiOaoWCuWqt1Ou16l9RpOgsvEMdocXbOZ7nQ7DjzTaeq7zq6P5fszfIASAYUBIYKDDoaGIImKC4ySH3OQEJKYHZWWi5iZG0ecEZ6eHEOio6SfqCaqpaytrpOwJLKztCO2jLi1uoW8Ir6/wCHCxMG2x7muysukzb230M6H09bX2Nna29zd3t/g4cAC5OXm5+jn3Ons7eba7vHt2fL16tj2+QL0+vXw/e7WAUwnrqDBgwgTKlzIsKHDh2gGSBwAccHEixAvaqTYcFCjRoYeNyoM6REhyZIHT4o0qPIjy5YTTcKUmHImx5cwE85cmJPnSYckK66sSAAj0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gwxZJAAA7) 0/14px no-repeat}", ""]);
	
	// exports


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if (media) {
			styleElement.setAttribute("media", media);
		}
	
		if (sourceMap) {
			// https://developer.chrome.com/devtools/docs/javascript-debugging
			// this makes source maps inside style tags work properly in Chrome
			css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */';
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}


/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    methods: {
	        reload: function reload() {
	            window.location.reload(true);
	        }
	    },
	    computed: {
	        errorMsg: function errorMsg() {
	            var status = this.config.status;
	            if (status == 1) {
	                //服务器开小差
	                return '系统开小差了，请稍后访问~';
	            } else if (status == 2) {
	                //暂无数据
	                return '无效的链接~';
	            }
	        }
	    },
	    props: ['config']
	};

/***/ },
/* 73 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.config.show) ? _c('div', {
	    staticClass: "vm-vap-error"
	  }, [_c('div', {
	    staticClass: "vm-vap-error-img"
	  }), _vm._v(" "), _c('p', {
	    staticClass: "vm-vap-error-msg"
	  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), (_vm.config.status === 1) ? _c('div', {
	    staticClass: "vm-vap-error-btn",
	    on: {
	      "click": _vm.reload
	    }
	  }, [_c('i'), _vm._v(" "), _c('span', {
	    staticClass: "btn-text"
	  }, [_vm._v("重新加载")])]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _promise = __webpack_require__(75);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _stringify = __webpack_require__(90);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(92);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _login = __webpack_require__(96);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Vue.http.options.credentials = true; /**
	                                      * Created by lijie on 2017/1/5.
	                                      */
	
	var Common = {
	    htmlEscape: function htmlEscape(string) {
	        var escapeMap = {
	            // '&': '&amp;',
	            '<': '&lt;',
	            '>': '&gt;',
	            '"': '&quot;',
	            "'": '&#x27;'
	        };
	        var escaper = function escaper(match) {
	            return escapeMap[match];
	        };
	        var source = '(?:' + (0, _keys2.default)(escapeMap).join('|') + ')';
	        var testRegexp = RegExp(source);
	        var replaceRegexp = RegExp(source, 'g');
	        string = string == null ? '' : '' + string;
	        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    },
	    getCookie: function getCookie(name) {
	        var cookie_start = document.cookie.indexOf(name + "="),
	            cookie_end = document.cookie.indexOf(";", cookie_start);
	        return cookie_start == -1 ? "" : unescape(document.cookie.substring(cookie_start + name.length + 1, cookie_end > cookie_start ? cookie_end : document.cookie.length));
	    },
	    vdianLogin: function vdianLogin() {
	        var url = _login2.default.login({
	            oauth: 0, //不显示第三方登录
	            device: 1, //移动端登录
	            force: 1 //不知道干嘛
	        });
	        location.href = url;
	    },
	    isSellerLogin: function isSellerLogin() {
	        return _login2.default.isSellerLogin();
	    },
	    isBuyerLogin: function isBuyerLogin() {
	        return _login2.default.isLogin();
	    },
	    wechatForceLogin: function wechatForceLogin() {
	        var url = _login2.default.wechatForceLogin();
	        location.href = url;
	    },
	    shouldLogin: function shouldLogin() {
	        if (!this.isBuyerLogin()) {
	            if (/MicroMessenger/i.test(navigator.userAgent) && !/wxwork/i.test(navigator.userAgent)) {
	                this.wechatForceLogin();
	            } else {
	                this.vdianLogin();
	            }
	        }
	    },
	    get: function get(url, data) {
	        if (/\/mock\//.test(url)) {
	            url += '/index.json';
	        }
	        var paramData = {};
	        if (data) {
	            paramData = { param: (0, _stringify2.default)(data) };
	        }
	        return new _promise2.default(function (resolve, reject) {
	            Vue.http.get(url, { params: paramData }).then(function (response) {
	                resolve({ data: response.body, header: response.headers });
	            }, reject);
	        });
	    },
	    ajax: function ajax(url, data) {
	        if (/\/mock\//.test(url)) {
	            return this.get(url, data);
	        } else {
	            var paramData = {};
	            if (data) {
	                paramData = { param: (0, _stringify2.default)(data) };
	            }
	            return new _promise2.default(function (resolve, reject) {
	                Vue.http.post(url, paramData, { emulateJSON: true }).then(function (response) {
	                    resolve({ data: response.body, header: response.headers });
	                }, reject);
	            });
	        }
	    },
	
	    //jsonp跨域处理
	    jsonp: function jsonp(url, data) {
	        if (/\/mock\//.test(url)) {
	            return this.get(url, data);
	        } else {
	            var paramData = {};
	            if (data) {
	                paramData = { params: { param: (0, _stringify2.default)(data) } };
	            }
	            return new _promise2.default(function (resolve, reject) {
	                Vue.http.jsonp(url, paramData, { emulateJSON: true }).then(function (response) {
	                    resolve({ data: response.body, header: response.headers });
	                }, reject);
	            });
	        }
	    },
	    jsonpVap: function jsonpVap(config) {
	        this.jsonp(config.url, config.dataIn).then(function (data) {
	            var resData = data && data.data || {};
	            if (resData.status && resData.status.status_code === 0) {
	                config.ok(resData);
	            } else {
	                //出错
	                config.error();
	            }
	        }, function () {
	            //断网
	            config.error();
	        });
	    },
	    post: function post(url, data) {
	        if (/\/mock\//.test(url)) {
	            return this.get(url, data);
	        } else {
	            var paramData = {};
	            if (data) {
	                paramData = { param: (0, _stringify2.default)(data) };
	            }
	            return new _promise2.default(function (resolve, reject) {
	                Vue.http.post(url, paramData, { emulateJSON: true }).then(function (response) {
	                    resolve({ data: response.body, header: response.headers });
	                }, reject);
	            });
	        }
	    },
	    thorPost: function thorPost(url, data) {
	        if (/\/mock\//.test(url)) {
	            return this.get(url, data);
	        } else {
	            var paramData = {};
	            if (data) {
	                paramData = { param: (0, _stringify2.default)(data) };
	            }
	            return new _promise2.default(function (resolve, reject) {
	                Vue.http.post(url, paramData, { emulateJSON: true }).then(function (response) {
	                    resolve({ data: response.body, header: response.headers });
	                }, reject);
	            });
	        }
	    },
	
	    //config.url  config.dataIn config.ok  config.error
	    vap: function vap(config) {
	        this.post(config.url, config.dataIn).then(function (data) {
	            var resData = data.data;
	            if (resData.status && resData.status.code === 0 && resData.result) {
	                if (resData.result.success === true) {
	                    //正常逻辑
	                    config.ok(resData.result);
	                } else {
	                    new Kub.Toast({
	                        top: 300,
	                        message: resData.result.errorMsg,
	                        delay: 1500
	                    });
	                }
	            } else if (resData.status && resData.status.code === 2) {
	                //登录
	                Common.vdianLogin();
	            } else {
	                //出错
	                config.error();
	            }
	        }, function () {
	            //断网
	            config.error();
	        });
	    },
	
	    //url添加时间戳
	    updateUrl: function updateUrl(url, key) {
	        var key = (key || 't') + '='; //默认是"t"
	        var reg = new RegExp(key + '\\d+'); //正则：t=1472286066028
	        var timestamp = +new Date();
	        if (url.indexOf(key) > -1) {
	            //有时间戳，直接更新
	            return url.replace(reg, key + timestamp);
	        } else {
	            //没有时间戳，加上时间戳
	            if (url.indexOf('\?') > -1) {
	                var urlArr = url.split('\?');
	                if (urlArr[1]) {
	                    return urlArr[0] + '?' + key + timestamp + '&' + urlArr[1];
	                } else {
	                    return urlArr[0] + '?' + key + timestamp;
	                }
	            } else {
	                if (url.indexOf('#') > -1) {
	                    return url.split('#')[0] + '?' + key + timestamp + location.hash;
	                } else {
	                    return url + '?' + key + timestamp;
	                }
	            }
	        }
	    },
	    format2Code: function format2Code(url) {
	        var pattern = /[&?]code=(.{10})(?:&|#|$)/;
	        var realCode = url.match(pattern) && url.match(pattern)[1];
	        var query = window.Kub.core.getQuerystring(url);
	        if (realCode) {
	            query.code = realCode;
	        }
	        return window.Kub.core.setQuerystring(url, query);
	    }
	};
	exports.default = Common;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(76), __esModule: true };

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(77);
	__webpack_require__(59);
	__webpack_require__(13);
	__webpack_require__(78);
	module.exports = __webpack_require__(26).Promise;

/***/ },
/* 77 */
/***/ function(module, exports) {



/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY            = __webpack_require__(23)
	  , global             = __webpack_require__(25)
	  , ctx                = __webpack_require__(27)
	  , classof            = __webpack_require__(63)
	  , $export            = __webpack_require__(24)
	  , isObject           = __webpack_require__(32)
	  , aFunction          = __webpack_require__(28)
	  , anInstance         = __webpack_require__(79)
	  , forOf              = __webpack_require__(80)
	  , speciesConstructor = __webpack_require__(83)
	  , task               = __webpack_require__(84).set
	  , microtask          = __webpack_require__(86)()
	  , PROMISE            = 'Promise'
	  , TypeError          = global.TypeError
	  , process            = global.process
	  , $Promise           = global[PROMISE]
	  , process            = global.process
	  , isNode             = classof(process) == 'process'
	  , empty              = function(){ /* empty */ }
	  , Internal, GenericPromiseCapability, Wrapper;
	
	var USE_NATIVE = !!function(){
	  try {
	    // correct subclassing with @@species support
	    var promise     = $Promise.resolve(1)
	      , FakePromise = (promise.constructor = {})[__webpack_require__(56)('species')] = function(exec){ exec(empty, empty); };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch(e){ /* empty */ }
	}();
	
	// helpers
	var sameConstructor = function(a, b){
	  // with library wrapper special case
	  return a === b || a === $Promise && b === Wrapper;
	};
	var isThenable = function(it){
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var newPromiseCapability = function(C){
	  return sameConstructor($Promise, C)
	    ? new PromiseCapability(C)
	    : new GenericPromiseCapability(C);
	};
	var PromiseCapability = GenericPromiseCapability = function(C){
	  var resolve, reject;
	  this.promise = new C(function($$resolve, $$reject){
	    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject  = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject  = aFunction(reject);
	};
	var perform = function(exec){
	  try {
	    exec();
	  } catch(e){
	    return {error: e};
	  }
	};
	var notify = function(promise, isReject){
	  if(promise._n)return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function(){
	    var value = promise._v
	      , ok    = promise._s == 1
	      , i     = 0;
	    var run = function(reaction){
	      var handler = ok ? reaction.ok : reaction.fail
	        , resolve = reaction.resolve
	        , reject  = reaction.reject
	        , domain  = reaction.domain
	        , result, then;
	      try {
	        if(handler){
	          if(!ok){
	            if(promise._h == 2)onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if(handler === true)result = value;
	          else {
	            if(domain)domain.enter();
	            result = handler(value);
	            if(domain)domain.exit();
	          }
	          if(result === reaction.promise){
	            reject(TypeError('Promise-chain cycle'));
	          } else if(then = isThenable(result)){
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch(e){
	        reject(e);
	      }
	    };
	    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if(isReject && !promise._h)onUnhandled(promise);
	  });
	};
	var onUnhandled = function(promise){
	  task.call(global, function(){
	    var value = promise._v
	      , abrupt, handler, console;
	    if(isUnhandled(promise)){
	      abrupt = perform(function(){
	        if(isNode){
	          process.emit('unhandledRejection', value, promise);
	        } else if(handler = global.onunhandledrejection){
	          handler({promise: promise, reason: value});
	        } else if((console = global.console) && console.error){
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if(abrupt)throw abrupt.error;
	  });
	};
	var isUnhandled = function(promise){
	  if(promise._h == 1)return false;
	  var chain = promise._a || promise._c
	    , i     = 0
	    , reaction;
	  while(chain.length > i){
	    reaction = chain[i++];
	    if(reaction.fail || !isUnhandled(reaction.promise))return false;
	  } return true;
	};
	var onHandleUnhandled = function(promise){
	  task.call(global, function(){
	    var handler;
	    if(isNode){
	      process.emit('rejectionHandled', promise);
	    } else if(handler = global.onrejectionhandled){
	      handler({promise: promise, reason: promise._v});
	    }
	  });
	};
	var $reject = function(value){
	  var promise = this;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if(!promise._a)promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function(value){
	  var promise = this
	    , then;
	  if(promise._d)return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if(promise === value)throw TypeError("Promise can't be resolved itself");
	    if(then = isThenable(value)){
	      microtask(function(){
	        var wrapper = {_w: promise, _d: false}; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch(e){
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch(e){
	    $reject.call({_w: promise, _d: false}, e); // wrap
	  }
	};
	
	// constructor polyfill
	if(!USE_NATIVE){
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor){
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch(err){
	      $reject.call(this, err);
	    }
	  };
	  Internal = function Promise(executor){
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(87)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected){
	      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail   = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if(this._a)this._a.push(reaction);
	      if(this._s)notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function(onRejected){
	      return this.then(undefined, onRejected);
	    }
	  });
	  PromiseCapability = function(){
	    var promise  = new Internal;
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject  = ctx($reject, promise, 1);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
	__webpack_require__(55)($Promise, PROMISE);
	__webpack_require__(88)(PROMISE);
	Wrapper = __webpack_require__(26)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r){
	    var capability = newPromiseCapability(this)
	      , $$reject   = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x){
	    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
	    var capability = newPromiseCapability(this)
	      , $$resolve  = capability.resolve;
	    $$resolve(x);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(89)(function(iter){
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , resolve    = capability.resolve
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      var values    = []
	        , index     = 0
	        , remaining = 1;
	      forOf(iterable, false, function(promise){
	        var $index        = index++
	          , alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function(value){
	          if(alreadyCalled)return;
	          alreadyCalled  = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable){
	    var C          = this
	      , capability = newPromiseCapability(C)
	      , reject     = capability.reject;
	    var abrupt = perform(function(){
	      forOf(iterable, false, function(promise){
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if(abrupt)reject(abrupt.error);
	    return capability.promise;
	  }
	});

/***/ },
/* 79 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name, forbiddenField){
	  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(27)
	  , call        = __webpack_require__(81)
	  , isArrayIter = __webpack_require__(82)
	  , anObject    = __webpack_require__(31)
	  , toLength    = __webpack_require__(47)
	  , getIterFn   = __webpack_require__(62)
	  , BREAK       = {}
	  , RETURN      = {};
	var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
	  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator, result;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if(result === BREAK || result === RETURN)return result;
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    result = call(iterator, f, step.value, entries);
	    if(result === BREAK || result === RETURN)return result;
	  }
	};
	exports.BREAK  = BREAK;
	exports.RETURN = RETURN;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(31);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(17)
	  , ITERATOR   = __webpack_require__(56)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject  = __webpack_require__(31)
	  , aFunction = __webpack_require__(28)
	  , SPECIES   = __webpack_require__(56)('species');
	module.exports = function(O, D){
	  var C = anObject(O).constructor, S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	var ctx                = __webpack_require__(27)
	  , invoke             = __webpack_require__(85)
	  , html               = __webpack_require__(54)
	  , cel                = __webpack_require__(36)
	  , global             = __webpack_require__(25)
	  , process            = global.process
	  , setTask            = global.setImmediate
	  , clearTask          = global.clearImmediate
	  , MessageChannel     = global.MessageChannel
	  , counter            = 0
	  , queue              = {}
	  , ONREADYSTATECHANGE = 'onreadystatechange'
	  , defer, channel, port;
	var run = function(){
	  var id = +this;
	  if(queue.hasOwnProperty(id)){
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function(event){
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if(!setTask || !clearTask){
	  setTask = function setImmediate(fn){
	    var args = [], i = 1;
	    while(arguments.length > i)args.push(arguments[i++]);
	    queue[++counter] = function(){
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id){
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if(__webpack_require__(20)(process) == 'process'){
	    defer = function(id){
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if(MessageChannel){
	    channel = new MessageChannel;
	    port    = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
	    defer = function(id){
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if(ONREADYSTATECHANGE in cel('script')){
	    defer = function(id){
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function(id){
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set:   setTask,
	  clear: clearTask
	};

/***/ },
/* 85 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function(fn, args, that){
	  var un = that === undefined;
	  switch(args.length){
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return              fn.apply(that, args);
	};

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(25)
	  , macrotask = __webpack_require__(84).set
	  , Observer  = global.MutationObserver || global.WebKitMutationObserver
	  , process   = global.process
	  , Promise   = global.Promise
	  , isNode    = __webpack_require__(20)(process) == 'process';
	
	module.exports = function(){
	  var head, last, notify;
	
	  var flush = function(){
	    var parent, fn;
	    if(isNode && (parent = process.domain))parent.exit();
	    while(head){
	      fn   = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch(e){
	        if(head)notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if(parent)parent.enter();
	  };
	
	  // Node.js
	  if(isNode){
	    notify = function(){
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if(Observer){
	    var toggle = true
	      , node   = document.createTextNode('');
	    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
	    notify = function(){
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if(Promise && Promise.resolve){
	    var promise = Promise.resolve();
	    notify = function(){
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function(){
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function(fn){
	    var task = {fn: fn, next: undefined};
	    if(last)last.next = task;
	    if(!head){
	      head = task;
	      notify();
	    } last = task;
	  };
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(29);
	module.exports = function(target, src, safe){
	  for(var key in src){
	    if(safe && target[key])target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global      = __webpack_require__(25)
	  , core        = __webpack_require__(26)
	  , dP          = __webpack_require__(30)
	  , DESCRIPTORS = __webpack_require__(34)
	  , SPECIES     = __webpack_require__(56)('species');
	
	module.exports = function(KEY){
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(56)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(91), __esModule: true };

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	var core  = __webpack_require__(26)
	  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
	module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(93), __esModule: true };

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(94);
	module.exports = __webpack_require__(26).Object.keys;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(58)
	  , $keys    = __webpack_require__(44);
	
	__webpack_require__(95)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(24)
	  , core    = __webpack_require__(26)
	  , fails   = __webpack_require__(35);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 96 */
/***/ function(module, exports) {

	!(function () {
	    var _window = window,
	        _document = document;
	    // 计数器初始化为0
	    var count = 0;
	    // 登录cookie字段
	    var IS_LOGIN = "is_login",
	        WD_B_ID = "uid",
	        // WD_B_WDUSS = "WD_b_wduss",
	        WD_S_ID = "sid",
	        // WD_S_WDUSS = "WD_s_wduss",
	        LOGIN_USER_SOURCE = "login_source";
	    // 错误码
	    var CODE_SUCCESS = 0,
	        CODE_FAILED = 2;
	    // 接口返回信息
	    var MSG_OK = "OK",
	        MSG_LOGIN_ERROR = "LOGIN ERROR";
	
	    /**
	          ## `environment`变量说明
	
	                0 : 开发
	                1 : 测试、日常
	                2 : 预发
	                3 : 线上
	    */
	    var ENV_MAP = {
	        DEV: 0,
	        DAILY: 1,
	        PRE: 2,
	        PROD: 3
	    }
	
	    function getHostObject(env) {
	        var bk = (env === ENV_MAP.DEV || env === ENV_MAP.DAILY) ? "-daily.test" : (env === ENV_MAP.PRE ? "-pre.test" : "");
	        var lp = (env === ENV_MAP.DEV || env === ENV_MAP.DAILY) ? ".daily" : (env === ENV_MAP.PRE ? ".pre" : "");
	        var sso = (env === ENV_MAP.DEV || env === ENV_MAP.DAILY) ? "wd.daily" : (env === ENV_MAP.PRE ? "wd.pre" : "sso");
	        return {
	            backendHost: "https://sso" + bk + ".weidian.com",
	            loginPageHost: "https://h5" + lp + ".weidian.com",
	            ssoPageHost: "https://" + sso + ".weidian.com", //新增北京ssohost
	            thorHost: "https://thor" + lp + ".weidian.com"
	        }
	    }
	
	    function getEnvironmentByUrl() {
	        var hostname = _window.location.hostname,
	            currentItem;
	        // currentItem = (currentItem = hostname.match(/(?:.)dev|daily|pre(?:.)/)) ? currentItem[0] : null;
	        currentItem = (currentItem = hostname.match(/(?=.)\bdev\b|\bdaily\b|\bpre\b(?=.)/)) ? currentItem[0] : null;
	        // hostArray = hostname.split("."),
	        //### ES5的 array.filter方法IE7,8不兼容,故果断抛弃
	        // currentItem = hostArray.filter(function(item) {
	        //     return /dev|daily|pre/.test(item);
	        // })[0];
	        switch (currentItem) {
	            case "dev":
	                return ENV_MAP.DEV;
	            case "daily":
	                return ENV_MAP.DAILY;
	            case "pre":
	                return ENV_MAP.PRE;
	            default:
	                return ENV_MAP.PROD;
	        }
	    }
	
	    function getHost(environment) {
	        var _env = environment === undefined ? getEnvironmentByUrl() : Number(environment);
	
	        return getHostObject(_env);
	    }
	
	    function getHref() {
	        return _window.location.href;
	    }
	
	    function getUA() {
	        return _window.navigator.userAgent;
	    }
	
	    function isMobile(type) {
	        // 如果不传，默认为h5
	        return (type === undefined) ? true : type;
	    }
	
	    function getTargetUrl(url) {
	        return url || getHref();
	    }
	
	    function getCookie(key) {
	        var result;
	
	        return (result = new RegExp('(?:^|; )' + key + '=([^;]*)').exec(_document.cookie)) ? result[1] : null;
	    }
	
	    // 格式化参数对象
	    function formatParams(data) {
	        var arry = [];
	        for (var name in data) {
	            if (typeof data[name] == "object") {
	                arry.push(name + '=' + JSON.stringify(data[name]));
	            }else{
	                arry.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
	            }
	            
	        }
	        return arry.join("&");
	    }
	
	    function vap() {
	        return {
	            status: {
	                code: "",
	                message: "",
	                description: ""
	            },
	            result: {}
	        };
	    }
	
	    function callback(data, success, error) {
	        // 模拟统一的vap接口格式
	        var infoResult = vap();
	
	        if (data && data.status) {
	            var status = data.status,
	                code = status.status_code,
	                message = status.message;
	
	            var tempCode, tempMsg;
	            switch (code) {
	                case 0:
	                    // 请求成功
	                    tempCode = CODE_SUCCESS;
	                    tempMsg = MSG_OK;
	                    break;
	                case 420010:
	                    // token校验失败
	                    tempCode = CODE_FAILED;
	                    tempMsg = MSG_LOGIN_ERROR;
	                    break;
	                default:
	                    // 其他类型错误
	                    tempCode = code;
	                    tempMsg = message;
	            }
	            infoResult.status.code = tempCode;
	            infoResult.status.message = tempMsg;
	            infoResult.result = data.result;
	
	            code === CODE_SUCCESS ? (success && success(infoResult)) : (error && error(infoResult));
	        } else {
	            error && error(new Error("interface isn't legal"));
	        }
	    }
	
	    function checkParam(param) {
	        return typeof param !== "undefined" ? true : false;
	    }
	
	    function getCompleteLink(domain, url, params) {
	        var link = "";
	        link = domain + url;
	        if (checkParam(params)) {
	            link += "?" + formatParams(params);
	        }
	        return link;
	    }
	
	    function jsonp(options) {
	        var options = options || {},
	            data = options.data || {},
	            jsonp = options.jsonp || "callback",
	            success = options.success,
	            error = options.error,
	            url = options.url,
	            responseData;
	
	        if (!url) {
	            return error && error(new Error("url is not defined!"));
	        }
	
	        // 动态创建script标签并添加到页面中
	        var callbackName = "jsonp_" + count++,
	            head = document.getElementsByTagName("head")[0],
	            _script = document.createElement("script");
	        // 将随机生成的回调函数存储在对象中
	        data[jsonp] = callbackName;
	
	        var onLoadCallback = (function () {
	            // 用handled标志位来防止“onreadystatechange”与“onload”两个监听事件重复调用本函数
	            var handled = false;
	            return function () {
	                if (handled) {
	                    return;
	                }
	                handled = true;
	                // 处理回调接口
	                if (!responseData) {
	                    error && error(new Error("callback function error!"));
	                } else {
	                    success && success(responseData);
	                }
	            };
	        }());
	        // 兼容部分IE 不支持onload事件的处理
	        // http://stackoverflow.com/questions/6806584/object-onload-in-internet-explorer-6-7-and-8
	        _script.onreadystatechange = function () {
	            if (this.readyState === "complete" || this.readyState === "loaded") {
	                onLoadCallback();
	            }
	        }
	        // 监听script的src属性请求的资源是否已经加载完成
	        _script.onload = onLoadCallback;
	        // 加载失败
	        _script.onerror = function (e) {
	            head.removeChild(_script);
	            window[callbackName] = null;
	            error && error(e);
	        }
	
	        // 封装jsonp回调函数
	        window[callbackName] = function (json) {
	            head.removeChild(_script);
	            window[callbackName] = null;
	            // 缓存请求返回的json数据
	            responseData = json;
	        }
	
	        // 发送请求
	        _script.src = url + (url.indexOf("?") == -1 ? '?' : '&') + formatParams(data);
	        head.appendChild(_script);
	    }
	    // 校验用户是否登录
	    function isLogin() {
	        return (getCookie(IS_LOGIN) || getCookie(WD_B_ID) || getCookie(WD_S_ID)) ? true : false;
	    }
	    // 校验是否纯卖家方式登录
	    function isSellerLogin() {
	        return isLogin() && getCookie(WD_S_ID) ? true : false;
	    }
	    // 校验是否通过微信第三方方式登录
	    function isWechatLogin() {
	        return isLogin() && getCookie(LOGIN_USER_SOURCE) === "LOGIN_USER_SOURCE_WECHAT" ? true : false;
	    }
	    // 校验是否通过通过qq方式登录
	    function isQQLogin() {
	        return isLogin() && getCookie(LOGIN_USER_SOURCE) === "LOGIN_USER_SOURCE_QQ" ? true : false;
	    }
	    // 校验是否在微信环境
	    function isWeixin() { //排除企业微信环境的干扰
	        return /MicroMessenger/i.test(getUA()) && !isWXwork();
	    }
	    // 校验是否在qq环境
	    function isQQ() {
	        return /QQ\/([\d\.]+)/i.test(getUA());
	    }
	    //判断企业微信
	    function isWXwork() {
	        return /wxwork/i.test(getUA());
	    }
	    // 当前登录用户是否开过店
	    function isOpenShop(opts) {
	        var opts = opts || {},
	            success = opts.success,
	            error = opts.error,
	            host = getHost(opts.environment),
	            CHECK_OPEN_SHOP_URL = host.thorHost + "/wdshop/shop.base.getShopExistInfo/1.0",
	            sellerId = getCookie(WD_S_ID);
	
	        if (!sellerId) {
	            return error && error(new Error("没获取到当前登录的卖家id"));
	        }
	
	        jsonp({
	            url: CHECK_OPEN_SHOP_URL,
	            data: {
	                context: {
	                    "shop_id": sellerId
	                }
	            },
	            success: function (data) {
	                success && success(data);
	            },
	            error: function (e) {
	                error && error(e);
	            }
	        });
	    }
	
	    // 校验第三方登录用户是否绑定了手机号
	    function getBindStatus(opts) {
	        /**
	         * 返回的结果为result=true，未绑定;result=false，已绑定
	         */
	        var opts = opts || {},
	            success = opts.success,
	            error = opts.error,
	            host = getHost(opts.environment),
	            CHECK_BIND_URL = host.backendHost + '/user/oauth/bind/getdemand';
	
	        jsonp({
	            url: CHECK_BIND_URL,
	            success: function (data) {
	
	                callback(data, function (result) {
	                    success && success(result);
	                }, function (e) {
	                    error && error(e);
	                });
	            },
	            error: function (e) {
	                error && error(e);
	            }
	        });
	    }
	
	    //获取登录用户信息
	    function getUserInfo(opts) {
	        /**
	            ###
	            1、校验是否有登录cookie值，因为调取用户信息接口需要cookie参数
	            2、校验当前浏览器是否支持CORS方式跨域；若支持则发起ajax请求(废弃，目前统一采用jsonp的方式处理)
	            3、若不支持，则采取jsonp的方式，动态创建script标签，利用src属性请求接口执行回调函数(因为要兼容IE7,8)
	
	            ###
	            opts:{
	            environment:环境值,
	            success:function(result){}//执行成功后的回调函数
	            error:function(result){}//执行失败后的回到函数
	        }
	        */
	        var host,
	            opts = opts || {},
	            success = opts.success,
	            error = opts.error,
	            host = getHost(opts.environment),
	            USER_INFO_URL = host.backendHost + "/user/getinfo";
	
	        // 模拟统一的vap接口格式
	        var infoResult = vap();
	
	        if (isLogin()) {
	            jsonp({
	                url: USER_INFO_URL,
	                success: function (data) {
	
	                    callback(data, function (result) {
	
	                        success && success(result);
	
	                    }, function (e) {
	
	                        error && error(e);
	
	                    });
	                },
	                error: function (e) {
	                    error && error(e);
	                }
	            });
	        } else {
	            infoResult.status.code = CODE_FAILED;
	            infoResult.status.message = MSG_LOGIN_ERROR;
	            infoResult.result = "";
	
	            error && error(infoResult);
	        }
	    }
	
	    function qqLogin(options) {
	        var options = options || {},
	            targetUrl = getTargetUrl(options.url),
	            host = getHost(options.environment),
	            type = options.device;
	
	        // _window.location.href = getCompleteLink(host.backendHost, '/user/oauth/qq/login', {
	        //     redirect: targetUrl,
	        //     type: isMobile(type) ? 'mobile' : 'pc'
	        // });
	
	        return getCompleteLink(host.backendHost, '/user/oauth/qq/login', {
	            redirect: targetUrl,
	            type: isMobile(type) ? 'mobile' : 'pc'
	        });
	    }
	
	    function wechatSlientLogin(options) {
	        var options = options || {},
	            targetUrl = getTargetUrl(options.url),
	            host = getHost(options.environment);
	
	        // _window.location.href = getCompleteLink(host.backendHost, '/user/oauth/wechat/silentlogin', {
	        //     redirect: targetUrl
	        // });
	        return getCompleteLink(host.backendHost, '/user/oauth/wechat/silentlogin', {
	            redirect: targetUrl
	        });
	    }
	
	    function wechatForceLogin(options) {
	        var options = options || {},
	            targetUrl = getTargetUrl(options.url),
	            host = getHost(options.environment);
	
	        // _window.location.href = getCompleteLink(host.backendHost, '/user/oauth/wechat/login', {
	        //     redirect: targetUrl
	        // });
	
	        return getCompleteLink(host.backendHost, '/user/oauth/wechat/login', {
	            redirect: targetUrl
	        });
	    }
	
	    function login(options) {
	        /**
	         ## 可选参数配置项
	          options:{
	          url: 重定向的url，若不传，则默认获取当前访问页面的url
	          environment:当前环境值，若不传，则默认解析识别当前页面的url的环境值
	          oauth:是否显示第三方登录；oauth=0不显示；不传参，默认显示
	          force:配置微信登录采用静默授权或强制授权；force=1为强制授权，不传，默认静默授权
	          bind: 配置第三方登录成功后是否跳转到绑定页面。bind=1 ：表示第三方登录成功后，如果账号未绑定手机号则跳转到绑定页面，绑定成功后跳转回目标页。默认为不跳转到绑定页面。
	          device:区别h5端或者pc端；h5端：device=1,pc端：device=0
	          }
	        */
	        var options = options || {},
	            host = getHost(options.environment),
	            targetUrl = encodeURIComponent(getTargetUrl(options.url));
	
	        //区分h5端登录和pc端登录
	        // _window.location.href = [host.loginPageHost,
	        //     isMobile(options.device) ? '/m/login/index.html' : '/m/signin/index.html',
	        //     '?redirect=' + targetUrl,
	        //     checkParam(options.oauth) ? '&oauth=0' : '',
	        //     checkParam(options.force) ? '&force=1' : '',
	        //     checkParam(options.bind) ? '&bind=1' : ''
	        // ].join('');
	
	        return [
	        // host.loginPageHost,
	        // isMobile(options.device) ? '/m/login/index.html' : '/m/signin/index.html',
	        isMobile(options.device) ? (host.ssoPageHost + '/login/index.php') : (host.loginPageHost + '/m/signin/index.html'),
	        '?redirect=' + targetUrl,
	        checkParam(options.oauth) ? '&oauth=0' : '',
	        checkParam(options.force) ? '&force=1' : '',
	        checkParam(options.bind) ? '&bind=1' : ''
	        ].join('');
	    }
	
	    function logout(options) {
	        var options = options || {},
	            targetUrl = getTargetUrl(options.url),
	            host = getHost(options.environment);
	
	        // _window.location.href = getCompleteLink(host.backendHost, '/user/logout', {
	        //     redirect: targetUrl
	        // });
	
	        return getCompleteLink(host.backendHost, '/user/logout', {
	            redirect: targetUrl
	        });
	    }
	
	    function bind(options) {
	        var options = options || {},
	            targetUrl = getTargetUrl(options.url),
	            host = getHost(options.environment);
	
	        // _window.location.href = getCompleteLink(host.loginPageHost, '/m/login/bind/index.html', {
	        //     redirect: targetUrl
	        // });
	
	        // return getCompleteLink(host.loginPageHost, '/m/login/bind/index.html', {
	        //     redirect: targetUrl
	        // });
	        return getCompleteLink(host.ssoPageHost, '/login/index.php', {
	            redirect: targetUrl,
	            bind: 1
	        });
	    }
	
	    var login = {
	        isLogin: isLogin,
	        isSellerLogin: isSellerLogin,
	        isWechatLogin: isWechatLogin,
	        isQQLogin: isQQLogin,
	        getUserInfo: getUserInfo,
	        qqLogin: qqLogin,
	        wechatSlientLogin: wechatSlientLogin,
	        wechatForceLogin: wechatForceLogin,
	        login: login,
	        logout: logout,
	        bind: bind,
	        getBindStatus: getBindStatus,
	        isWeixin: isWeixin,
	        isQQ: isQQ,
	        isOpenShop: isOpenShop
	    }
	
	    if (typeof module !== "undefined" && module.exports) {
	        module.exports = login;
	    } else {
	        _window.login = login;
	    }
	})()


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * /*
	 * @author:  caixianglin
	 * @createTime: 2017-05-16, 14:12:40 GMT+0800
	 */
	'use strict';
	
	var config = __webpack_require__(98);
	//const target = '?debug=true&strictTarget=172.18.24.241:2180';
	var target = '';
	module.exports = {
	    host: config.host,
	    api: config.api,
	    getTurnplateInfo: config.api + 'vfun/lottery.getBaseInfo/1.0' + target,
	    getInteractionInfo: config.api + 'vfun/turnplateLottery.getInteractionInfo/1.0' + target,
	    play: config.api + 'vfun/turnplateLottery.play/1.0' + target,
	    getWinerCode: config.api + 'vfun/lottery.getWinerCode/1.0' + target,
	    getWinerRecord: config.api + 'vfun/winer.getMyRecords/1.0' + target,
	    getShare: config.api + 'vfun/vfun.getShare/1.0' + target,
	    getShopInfo2: '//wd80.test.weidian.com/shop/service/getPubInfo',
	    getShopInfo: '//shop.api.weidian.com/shop/service/getPubInfo',
	    getRemainPlayTimes: config.api + 'vfun/lottery.getRemainPlayTimes/1.0',
	    myCalculusLink: 'https://vmspub.weidian.com/gaia/9346/ac93327e.html', //我的微积分
	    openCalculusLink: config.host + '/m/vpoint-packet/index.html?bizType=406&shopId=', //领取微积分
	    getShopId: config.thorHost + 'promotion/vpointpacket.seller.getShopInfo/1.0' //获取微积分相关的shopId
	};

/***/ },
/* 98 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Created by qiuleo on 16/11/15.
	 */
	module.exports = {
	    host: 'https://h5.weidian.com',
	    api: '//thor.weidian.com/',
	    thorHost: 'https://thor.weidian.com/'
	};

/***/ },
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(117)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(116)(module)))

/***/ },
/* 116 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./zh-cn": 118,
		"./zh-cn.js": 118
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 117;


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(115)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vueResource = __webpack_require__(8);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _turnplateNew = __webpack_require__(163);
	
	var _turnplateNew2 = _interopRequireDefault(_turnplateNew);
	
	var _coupon = __webpack_require__(168);
	
	var _coupon2 = _interopRequireDefault(_coupon);
	
	var _getawardNew = __webpack_require__(173);
	
	var _getawardNew2 = _interopRequireDefault(_getawardNew);
	
	var _intro = __webpack_require__(180);
	
	var _intro2 = _interopRequireDefault(_intro);
	
	__webpack_require__(189);
	
	var _moment = __webpack_require__(115);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _common = __webpack_require__(74);
	
	var _common2 = _interopRequireDefault(_common);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Vue.use(_vueResource2.default);
	Vue.config.silent = false; //取消vue所有的日志和警告
	
	_common2.default.shouldLogin();
	
	window.requestAnimFrame = function () {
	    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (callback) {
	        window.setTimeout(callback, 1000 / 60);
	    };
	}();
	
	Vue.filter('time', function (value) {
	    return (0, _moment2.default)(value).format("YYYY-MM-DD HH:mm");
	});
	
	var routes = [{ path: '/', redirect: '/turnplate' }, {
	    path: '/turnplate',
	    component: _turnplateNew2.default,
	    name: 'turnplate'
	}, {
	    path: '/coupon',
	    component: _coupon2.default,
	    name: 'coupon'
	}, {
	    path: '/intro/:shopId',
	    component: _intro2.default,
	    name: 'intro'
	}];
	
	var router = new VueRouter({
	    routes: routes
	});
	
	var main = new Vue({
	    router: router,
	    components: {
	        'vm-get-award': _getawardNew2.default
	    },
	    created: function created() {
	        if (this.$route.path.search('&') !== -1) {
	            this.$router.push({ path: '/turnplate' });
	        }
	    },
	    methods: {},
	    data: function data() {
	        return {};
	    }
	}).$mount('#main');

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(164)
	
	/* script */
	__vue_exports__ = __webpack_require__(166)
	
	/* template */
	var __vue_template__ = __webpack_require__(167)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(165);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(71)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-ec2e45aa!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./turnplate-new.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-ec2e45aa!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./turnplate-new.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(66)();
	// imports
	
	
	// module
	exports.push([module.id, "#main-container{font-size:0;width:10rem;max-width:10rem;height:100%;position:fixed;top:0;bottom:0;left:0;right:0;overflow-x:hidden;margin:0 auto;background:url(\"https://si.geilicdn.com/hz_img_01270000015c3477c2710a02685e_750_1206_unadjust.png\") no-repeat 50%;background-size:cover}#turnplate{position:relative;width:100%;height:100%;z-index:1;-webkit-transform:translateZ(0);transform:translateZ(0)}#turnplate .outer-1{width:9.2rem;height:9.2rem;background:url(\"data:image/png;base64,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\") no-repeat 50%;background-size:contain;position:absolute;top:4.13333333rem;left:.4rem}#turnplate .outer-2{width:8.4rem;height:8.4rem;margin:0 auto;background:url(\"data:image/gif;base64,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\") no-repeat 50%;background-size:contain;position:absolute;top:4.46666667rem;left:.86666667rem}#turnplate .real-deg{top:4.93333333rem;left:1.33333333rem;font-size:0;z-index:100;border-radius:50%;overflow:hidden}#turnplate .inner-1,#turnplate .real-deg{width:7.46666667rem;height:7.46666667rem;position:absolute}#turnplate .inner-1{background-size:cover}#turnplate .inner-2{width:2.10666667rem;height:2.24rem;text-align:center;position:absolute;z-index:102;top:7.53333333rem;left:4rem;cursor:pointer;background:url(\"data:image/png;base64,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\") no-repeat 50%;background-size:contain}#turnplate .invalid{background-image:url(\"data:image/png;base64,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\")}#turnplate .lottery-word-1{font-size:.64rem;padding-top:.13333333rem;color:#fff;line-height:2.33333333rem;text-align:center;position:relative;z-index:1}#turnplate .btn{width:3.33333333rem;height:1.33333333rem;font-size:.37333333rem;position:absolute;text-align:center;line-height:1.17333333rem;top:14.4rem;color:#fff;font-weight:bolder;background:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAP4AAABlCAMAAABa6a7jAAAA2FBMVEUAAAD/nQD/nQD/nQCSXSL/nQC+dh/diAv/nQDykwD+mgAyJzb/nQCSXiqqayUyJzb/nQAyJzbTghP/nQD/nQAyJzbeiQn/nQDnjgD/nQAyJzYyJzYyJzYyJzb/nQCYPezSm/8yJzb/nQCBJNeXO+yVOeqWOuqUOOmSNuaRNOWFJ9qPM+STN+iJLN6EJtmQNOSGKNyKLd+DJdiOMeOIK92NL+GLLuB2NrA9KUw2KD49LjVUOjSLOtSBN8RkMJJTL3E3KUFoRzByTC9zJbtoJ6NILV5JNDWLWix35X4eAAAAH3RSTlMAD0krBPLt2NWwengh/vbw49vGva6jn4hyVk5HKxEI9x325gAAAnJJREFUeNrtnMd2m1AURZ+Ku9N7vYFXqAKEFRfJJXHa//9RHpIjgQURcpn43DPYEsz2Wo/NDFHZngO2iv17B21l+49PHLSV7D89m975ArOK/u53x/kGq9/9Y6+OUPV7j+3FOYHqdzbt/wsKMPX7z8eO88tQhKn/+rfjHJ96anH46UGvqv92YqN/GsgQUr9rX3knZxTJBFG/t1G88gyRrwH195+69teXGREFcPqdbbfQLx58oghO/4U71afYkAYsv3ulTxTIDFk/kjmuPmj5rT1y+V0Xuvwul5/Lz+XHLv+Iy8/lB9Xn8oOXPwAufw5e/gS6/L4hTbCHn8sPXX5FFHiw+lx+7PJrMlx+XH0uP6x+PC2/j6rP5Qcvv8/lh9VHL/+Ay8/lB9Un8nPw8ktcffDyJ1x+Lj+qflH+EbL+AXL57VIuP6h+KvPi/KPqU6BJcflx9bn8sPpxMuTyA5ff4/Ij66OXP4ph9eOQy8/lR9Un8hMuP66+4vLDfbimWn5U/Vn58T5aVS7/AFnflh9Z35YfVv9f+cF2vfxgmx/+tCi/csBWLf81xsmoNTNLb5lhplZRr2BoVtE0Uzfw7NhKv+pXy6+qjFowXWIgpWlHX0rdmh5R3IKelPFq/jyxzntCVMtfol9LugMG6zFtw7SeQQPPrfH4g1joq2FERGZw0MCvtVRr8/AGpBmHMw5vy8P8wgpPtkRJX8sRFaciq6W+YvhfJnOaGuYNlHOqm1I1k5b5o3jsL3c+l/VJKypszb1Rr0d9XzwqHvtHu0Is9ME23uwKXP3J1r7A1b/c6YiFPtze9AWu/sY7IXD1t3sCWP9lp2r/F9hIZeLm4EQvAAAAAElFTkSuQmCC\") no-repeat 50%;background-size:contain}#turnplate #btn1{left:1.2rem}#turnplate #btn2{left:5.46666667rem}#turnplate #btn1 a,#turnplate #btn2 a{display:block;text-decoration:none;color:inherit}#turnplate .chance-left{position:absolute;top:13.6rem;text-align:center;font-size:.4rem;width:100%}#turnplate .chance-left span{color:#f43531}@-webkit-keyframes spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}#turnplate .avatar{-webkit-animation:spin .5s infinite linear;animation:spin .5s infinite linear;-webkit-transform-origin:50% 50%;transform-origin:50% 50%}@-webkit-keyframes spinend{to{-webkit-transform:rotate(6turn);transform:rotate(6turn)}}@keyframes spinend{to{-webkit-transform:rotate(6turn);transform:rotate(6turn)}}#turnplate .avatarend{-webkit-animation:spinend 3.5s -.67s 1 cubic-bezier(.075,.82,.165,1);animation:spinend 3.5s -.67s 1 cubic-bezier(.075,.82,.165,1);-webkit-transform-origin:50% 50%;transform-origin:50% 50%}", ""]);
	
	// exports


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _error = __webpack_require__(68);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _common = __webpack_require__(74);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _api = __webpack_require__(97);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timer; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    data: function data() {
	        return {
	            panelRotateClass: '',
	            panelStyle: {},
	            outerPanelClass: '',
	            panelImg: null,
	            errorConfig: {
	                show: false,
	                status: 1
	            },
	            panelInfo: null,
	            interactionInfo: null,
	            winnerRecord: null,
	            playData: null,
	            timesUsed: 0,
	            duringPlay: false,
	            catchAward: 0,
	            activityStatus: 0, //0 正常 1 未开始 2已结束 3 已下线
	            activityStatusStr: '',
	            shopId: ''
	        };
	    },
	
	    methods: {
	        startRotate: function startRotate() {
	            this.panelRotateClass = 'avatar'; //内盘转动
	            this.outerPanelClass = ''; //外盘不动
	            this.panelStyle = { //内盘角度归位
	                backgroundImage: 'url(' + this.panelImg + ')'
	            };
	            this.duringPlay = true;
	        },
	        stopRotate: function stopRotate(deg, cb) {
	            var doAnimation = function () {
	                //内盘定位
	                this.panelStyle = {
	                    backgroundImage: 'url(' + this.panelImg + ')',
	                    transform: 'rotate(' + deg + 'deg)',
	                    WebkitTransform: 'rotate(' + deg + 'deg)'
	                };
	                this.outerPanelClass = 'avatarend'; //外盘动
	                this.panelRotateClass = ''; //内盘不动
	                if (cb) {
	                    setTimeout(function () {
	                        cb();
	                        this.duringPlay = false;
	                    }.bind(this), 3200);
	                } else {
	                    this.duringPlay = false;
	                }
	            }.bind(this);
	            var ua = window.navigator.userAgent.toLowerCase(),
	                iPhone = /iphone/i.test(ua),
	                android = /android/i.test(ua);
	            if (iPhone) {
	                doAnimation();
	            } else {
	                requestAnimFrame(doAnimation);
	            }
	        },
	        getShareConfig: function getShareConfig() {
	            var self = this;
	            _common2.default.post(_api2.default.getShare, {
	                activityId: app.id, //抽奖id
	                activityType: 1
	            }).then(function (data) {
	                var resData = data.data;
	                if (resData.status && resData.status.code === 0 && resData.result) {
	                    var result = resData.result;
	                    if (result.data) {
	                        //分享配置
	                        var title = void 0,
	                            pyq = void 0,
	                            content = void 0,
	                            img = void 0;
	                        title = result.data.title;
	                        pyq = result.data.title;
	                        content = result.data.description;
	                        img = result.data.imgHead;
	                        if (!/^https?/.test(img)) {
	                            img = window.location.protocol + img;
	                        }
	                        var share = window.pathTracker.share({
	                            config: {
	                                title: title,
	                                pyq: pyq,
	                                content: content,
	                                url: _common2.default.format2Code(window.location.href),
	                                img: img
	                            },
	                            option: {
	                                shareChannel: ["chats", "moments", "qq", 'qzone'],
	                                showTips: true,
	                                prependHtml: ''
	                            }
	                        });
	                    }
	                } else if (resData.status && resData.status.code === 2) {
	                    _common2.default.vdianLogin();
	                }
	            }, function () {
	                self.errorConfig = { show: true, status: 1 };
	            });
	        },
	        getTurnplateInfo: function getTurnplateInfo() {
	            var self = this;
	            _common2.default.post(_api2.default.getTurnplateInfo, {
	                id: app.id, //抽奖id
	                code: app.code
	            }).then(function (data) {
	                var resData = data.data;
	                if (resData.status && resData.status.code === 0 && resData.result) {
	                    var result = resData.result;
	                    if (result.data) {
	                        result.data.features = JSON.parse(result.data.features);
	                        self.shopId = result.data.author;
	                        window.sessionStorage.setItem('description', result.data.description);
	                        self.panelInfo = result;
	                        document.title = self.panelInfo.data.name || '参与活动赢大奖';
	                    }
	
	                    //活动还没开始，下架也展示
	                    if (resData.result.success === false) {
	                        var errorCode = resData.result.errorCode;
	                        if (errorCode === 31101) {
	                            self.activityStatus = 1;
	                        } else if (errorCode === 31102) {
	                            self.activityStatus = 2;
	                        } else if (errorCode === 31103) {
	                            self.activityStatus = 3;
	                        } else {
	                            self.activityStatus = 999; //其他错误
	                        }
	                        self.activityStatusStr = resData.result.errorMsg;
	                        new Kub.Toast({
	                            top: 300,
	                            message: resData.result.errorMsg,
	                            delay: 1500
	                        });
	                    }
	                } else if (resData.status && resData.status.code === 2) {
	                    _common2.default.vdianLogin();
	                } else {
	                    self.errorConfig = { show: true, status: 1 };
	                }
	            }, function () {
	                self.errorConfig = { show: true, status: 1 };
	            });
	        },
	        getInteractionInfo: function getInteractionInfo() {
	            var self = this;
	            _common2.default.vap({
	                url: _api2.default.getInteractionInfo,
	                dataIn: {
	                    id: app.id, //抽奖id
	                    code: app.code
	                },
	                ok: function ok(result) {
	                    self.interactionInfo = result;
	                },
	                error: function error() {
	                    self.errorConfig = { show: true, status: 1 };
	                }
	            });
	        },
	        getWinnerRecord: function getWinnerRecord() {
	            var self = this;
	            _common2.default.vap({
	                url: _api2.default.getWinerRecord,
	                dataIn: {
	                    activityId: app.id, //转盘id
	                    code: app.code,
	                    activityType: 1
	                },
	                ok: function ok(result) {
	                    self.winnerRecord = result;
	                },
	                error: function error() {
	                    self.errorConfig = { show: true, status: 1 };
	                }
	            });
	        },
	        vapPlay: function vapPlay() {
	            var self = this;
	            _common2.default.post(_api2.default.play, {
	                id: app.id, //抽奖id
	                code: app.code
	            }).then(function (data) {
	                var resData = data.data;
	                if (resData.status && resData.status.code === 0 && resData.result) {
	                    if (resData.result.success === true) {
	                        //正常逻辑
	                        self.playData = resData.result;
	                    } else {
	                        clearInterval(timer);
	                        self.stopRotate(0);
	                        new Kub.Toast({
	                            top: 300,
	                            message: resData.result.errorMsg,
	                            delay: 1500
	                        });
	                        //如果次数用完，刷新页面
	                        if (resData.result.errorCode === 31104) {
	                            setTimeout(function () {
	                                location.reload(true);
	                            }, 1500);
	                        }
	                    }
	                } else if (resData.status && resData.status.code === 2) {
	                    //登录
	                    _common2.default.vdianLogin();
	                } else {
	                    //出错
	                    clearInterval(timer);
	                    self.stopRotate(0);
	                    self.errorConfig = { show: true, status: 1 };
	                }
	            }, function () {
	                //断网
	                clearInterval(timer);
	                self.stopRotate(0);
	                self.errorConfig = { show: true, status: 1 };
	            });
	        },
	        play: function play() {
	            if (this.activityStatus === 0 && this.chanceLeft > 0 && !this.duringPlay) {
	                var rotateTime = 2000,
	                    self = this;
	                this.playData = null;
	                this.startRotate();
	                this.vapPlay();
	                setTimeout(function () {
	                    if (self.playData) {
	                        self.handlePlayResult();
	                    } else {
	                        //Todo 可以简化VAP 2S 超时
	                        timer = setInterval(function () {
	                            if (self.playData) {
	                                clearInterval(timer);
	                                self.handlePlayResult();
	                            }
	                        }, 1000);
	                    }
	                }, rotateTime);
	            }
	        },
	        handlePlayResult: function handlePlayResult() {
	            var self = this,
	                stopDeg = void 0;
	            stopDeg = this.computedDeg(this.playData.data.features);
	            if (this.playData.data && this.playData.data.id) {
	                //中奖
	                this.stopRotate(stopDeg, function () {
	                    var data = self.playData.data;
	                    eventBus.$emit('show', data);
	                    self.timesUsed++;
	                    self.catchAward++;
	                });
	            } else {
	                //没中奖
	                this.stopRotate(stopDeg, function () {
	                    self.timesUsed++;
	                });
	            }
	        },
	        computedDeg: function computedDeg(features) {
	            var deg = void 0;
	            try {
	                var featuresObj = JSON.parse(features),
	                    winerInfoObj = featuresObj.winerInfo;
	                var index = winerInfoObj.index,
	                    partNum = winerInfoObj.partNum;
	
	                deg = (partNum + 1 - index) * 360 / partNum;
	                deg = ~~deg;
	            } catch (e) {
	                deg = 0;
	            }
	            return deg;
	        }
	    },
	    computed: {
	        pointerClass: function pointerClass() {
	            if (this.activityStatus === 0) {
	                if (this.chanceLeft > 0) {
	                    return 'valid';
	                } else {
	                    return 'invalid';
	                }
	            } else {
	                return 'invalid';
	            }
	        },
	        chanceLeft: function chanceLeft() {
	            var value = void 0;
	            if (this.panelInfo && this.interactionInfo) {
	                value = this.panelInfo.data.participationLimit - this.interactionInfo.totalCount - this.timesUsed;
	                if (value < 0) {
	                    value = 0;
	                }
	            } else {
	                value = 0;
	            }
	            return value;
	        },
	        awardCnt: function awardCnt() {
	            if (this.winnerRecord) {
	                var awardsNotTaken = 0;
	                this.winnerRecord.data.forEach(function (item) {
	                    /*if (item.status === 0) {
	                        awardsNotTaken++;
	                    }*/
	                    awardsNotTaken++;
	                    //奖品项就是所有中奖纪录
	                });
	                return awardsNotTaken + this.catchAward;
	            } else {
	                return this.catchAward;
	            }
	        },
	        couldRender: function couldRender() {
	            return !this.errorConfig.show && this.interactionInfo && this.panelInfo && this.winnerRecord;
	        }
	    },
	    components: {
	        'vm-error': _error2.default
	    },
	    watch: {
	        panelInfo: function panelInfo(val) {
	            if (val) {
	                var img = val.data.features.backgroudPic;
	                this.panelImg = img;
	                this.panelStyle = {
	                    backgroundImage: 'url(' + img + ')'
	                };
	            }
	        }
	    },
	    created: function created() {
	        this.getTurnplateInfo();
	        this.getInteractionInfo();
	        this.getWinnerRecord();
	        this.getShareConfig();
	    },
	    mounted: function mounted() {
	        var self = this;
	        if (app.code === undefined || app.id === undefined) {
	            self.errorConfig = { show: true, status: 2 };
	        }
	        window.addEventListener('touchmove', function (e) {
	            if (self.duringPlay) {
	                e.preventDefault();
	            }
	        });
	    },
	    beforeDestroy: function beforeDestroy() {
	        eventBus.$emit('hide');
	    }
	};

/***/ },
/* 167 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.couldRender) ? _c('div', {
	    attrs: {
	      "id": "main-container"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "turnplate"
	    }
	  }, [_c('div', {
	    staticClass: "outer-1"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "outer-2"
	  }), _vm._v(" "), _c('div', {
	    class: ['real-deg', _vm.outerPanelClass]
	  }, [_c('div', {
	    class: ['inner-1', _vm.panelRotateClass],
	    style: (_vm.panelStyle)
	  })]), _vm._v(" "), _c('div', {
	    class: ['inner-2', _vm.pointerClass],
	    on: {
	      "click": _vm.play
	    }
	  }), _vm._v(" "), (_vm.activityStatus === 0) ? _c('div', {
	    staticClass: "chance-left"
	  }, [_vm._v("你今天还有"), _c('span', [_vm._v(_vm._s(_vm.chanceLeft))]), _vm._v("次抽奖机会")]) : (_vm.activityStatus >= 1 && _vm.activityStatus <= 3) ? _c('div', {
	    staticClass: "chance-left"
	  }, [_vm._v(_vm._s(_vm.activityStatusStr))]) : _vm._e(), _vm._v(" "), _vm._v(" "), _c('div', {
	    staticClass: "btn",
	    attrs: {
	      "id": "btn1"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        path: '/intro/' + _vm.shopId
	      }
	    }
	  }, [_vm._v("活动介绍")])]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "tag": "div",
	      "to": {
	        path: '/coupon'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "btn",
	    attrs: {
	      "id": "btn2"
	    }
	  }, [_vm._v("我的奖品"), (_vm.awardCnt > 0) ? _c('span', [_vm._v(" " + _vm._s(_vm.awardCnt))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('vm-error', {
	    attrs: {
	      "config": _vm.errorConfig
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(169)
	
	/* script */
	__vue_exports__ = __webpack_require__(171)
	
	/* template */
	var __vue_template__ = __webpack_require__(172)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(170);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(71)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3e179b97!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./coupon.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-3e179b97!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./coupon.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(66)();
	// imports
	
	
	// module
	exports.push([module.id, "#coupon{width:100%}#coupon ul>li{margin:0 auto;width:9.57333333rem;height:3.14666667rem;background:url(\"data:image/png;base64,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\") no-repeat 50%;background-size:cover;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-line-pack:center;align-content:center}#coupon ul>li:first-child{margin-top:.26666667rem}#coupon ul>li:last-child{margin-bottom:.26666667rem}#coupon ul>li .coupon-left{width:2.94666667rem;text-align:center;color:#fe5a4c;margin-left:.2rem}#coupon ul>li .coupon-left p{font-size:.85333333rem;font-weight:bolder;line-height:.85333333rem;margin-bottom:.26666667rem}#coupon ul>li .coupon-left p span{display:inline;font-size:.48rem;line-height:.48rem}#coupon ul>li .coupon-left span{display:block;line-height:.32rem;font-size:.32rem}#coupon ul>li .coupon-right{-webkit-box-flex:1;-ms-flex:1;flex:1;font-size:.32rem;margin-left:.48rem}#coupon ul>li .coupon-right p{color:#333;line-height:.32rem;margin-bottom:.26666667rem}#coupon ul>li .coupon-right span{display:block;text-align:center;text-decoration:none;color:#fff;background-color:#fe5a4c;height:.48rem;width:1.85333333rem;line-height:.48rem;border-radius:.05333333rem}#coupon .end{font-size:13px}#coupon .end,#coupon .no-record{line-height:18px;text-align:center;color:#999}#coupon .no-record{padding:.53333333rem;padding-top:2.08rem;font-size:14px}", ""]);
	
	// exports


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _error = __webpack_require__(68);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _common = __webpack_require__(74);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _api = __webpack_require__(97);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            winnerRecord: null,
	            errorConfig: {
	                show: false,
	                status: 1
	            },
	            noRecord: false
	        };
	    },
	
	    filters: {
	        money: function money(val) {
	            return parseFloat(val / 100);
	        }
	    },
	    created: function created() {
	        this.getWinnerRecord();
	    },
	
	    methods: {
	        getWinnerRecord: function getWinnerRecord() {
	            var self = this;
	            _common2.default.vap({
	                url: _api2.default.getWinerRecord,
	                dataIn: {
	                    activityId: app.id, //转盘id
	                    code: app.code,
	                    activityType: 1
	                },
	                ok: function ok(result) {
	                    self.winnerRecord = self.formatData(result);
	                    if (result.data.length === 0) {
	                        self.noRecord = true;
	                    }
	                },
	                error: function error() {
	                    self.errorConfig = { show: true, status: 1 };
	                }
	            });
	        },
	        formatData: function formatData(res) {
	            res.data.forEach(function (item, index) {
	                item.features !== "" && (item.features = JSON.parse(item.features));
	            });
	            return res;
	        },
	        use: function use(shopId, couponId, type, e) {
	            //0全店优惠券，1部分商品优惠券
	            var originUrl = void 0;
	            if (type == 0) {
	                originUrl = "https://weidian.com/?userid=" + shopId;
	            } else if (type == 1) {
	                originUrl = _api2.default.host + '/m/mycoupon/list.html?shop_id=' + shopId + '&coupon_id=' + couponId;
	            }
	            var newUrl = spider.transferActionBy(originUrl, e.currentTarget);
	            location.href = newUrl;
	        }
	    },
	    components: {
	        'vm-error': _error2.default
	    },
	    mounted: function mounted() {
	        var self = this;
	        if (app.code === undefined || app.id === undefined) {
	            self.errorConfig = { show: true, status: 2 };
	        }
	        document.title = '我的奖品';
	    }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ },
/* 172 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "coupon",
	      "data-spider": "coupon_list"
	    }
	  }, [(!_vm.errorConfig.show && _vm.winnerRecord) ? _c('div', [_c('ul', _vm._l((_vm.winnerRecord.data), function(item, index) {
	    return (item.awardType === 2) ? _c('li', {
	      attrs: {
	        "data-spider": ""
	      },
	      on: {
	        "click": function($event) {
	          _vm.use(item.features.coupon.shopId, item.features.coupon.couponId, item.features.coupon.type, $event)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "coupon-left"
	    }, [_c('p', [_c('span', [_vm._v("¥")]), _vm._v(_vm._s(_vm._f("money")(item.features.coupon.reduce)))]), _vm._v(" "), _c('span', [_vm._v("满" + _vm._s(_vm._f("money")(item.features.coupon.full)) + "元可用")])]), _vm._v(" "), _c('div', {
	      staticClass: "coupon-right"
	    }, [_c('p', [_vm._v("中奖时间：" + _vm._s(_vm._f("time")(item.gmtCreated)))]), _vm._v(" "), _c('span', [_vm._v("立即使用")])])]) : _vm._e()
	  })), _vm._v(" "), (_vm.winnerRecord.data.length > 0) ? _c('p', {
	    staticClass: "end"
	  }, [_vm._v("～奖品已经看完了～")]) : _vm._e(), _vm._v(" "), (_vm.noRecord) ? _c('p', {
	    staticClass: "no-record"
	  }, [_vm._v("～暂无奖品，再接再厉！～")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('vm-error', {
	    attrs: {
	      "config": _vm.errorConfig
	    }
	  })])
	},staticRenderFns: []}

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(174)
	
	/* script */
	__vue_exports__ = __webpack_require__(176)
	
	/* template */
	var __vue_template__ = __webpack_require__(179)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(175);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(71)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-4f11564b!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./getaward-new.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-4f11564b!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./getaward-new.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(66)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(177);
	
	var _api = __webpack_require__(97);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    data: function data() {
	        return {
	            show: false,
	            name: '',
	            time: '',
	            img: '',
	            code: '',
	            awardId: -1,
	            awardType: -1, //1实物 2 优惠券
	            couponLink: '#',
	            coupon: {}
	        };
	    },
	
	    components: {},
	    methods: {
	        cancel: function cancel() {
	            this.show = false;
	        },
	        touchMove: function touchMove(e) {
	            e.preventDefault();
	            e.stopPropagation();
	        }
	    },
	    mounted: function mounted() {
	        var self = this;
	        eventBus.$on('show', function (data) {
	            self.show = true;
	            self.img = data.pic;
	            self.code = data.winerCode;
	            self.awardId = data.id;
	            self.awardType = data.awardType;
	            self.coupon = JSON.parse(data.features).coupon;
	            self.name = '满' + parseFloat(self.coupon.full / 100) + '减' + parseFloat(self.coupon.reduce / 100) + '优惠券';
	
	            if (data.awardType === 2) {
	                //优惠券
	                if (self.coupon.type == 0) {
	                    // self.couponLink = config.host+'/m/weidian-buyer/shop/index.html?shopId='+self.coupon.shopId;
	                    self.couponLink = "https://weidian.com/?userid=" + self.coupon.shopId;
	                } else {
	                    self.couponLink = _api2.default.host + '/m/mycoupon/list.html?shop_id=' + self.coupon.shopId + '&coupon_id=' + self.coupon.couponId;
	                }
	            }
	        });
	        eventBus.$on('hide', function (data) {
	            self.show = false;
	        });
	    }
	};

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(178);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(67)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!../../../node_modules/postcss-loader/index.js!./getaward-new.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!../../../node_modules/postcss-loader/index.js!./getaward-new.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(66)();
	// imports
	
	
	// module
	exports.push([module.id, "#got-award .mask{position:fixed;z-index:2;left:0;right:0;top:0;bottom:0;max-width:10rem;margin:0 auto;background-color:rgba(0,0,0,.5)}#got-award .of{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}#got-award .content{width:7.33333333rem;box-sizing:border-box;font-size:0;height:9.16rem;position:absolute;left:0;right:0;bottom:4.13333333rem;margin:0 auto;text-align:center;background:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAiYAAAKvCAMAAABpr/RkAAACQFBMVEUAAAD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/2Cz/////nQA+Kyz/0Sb/1Sn/0ST/twD/yRz/vw75zC3/WGDetTH/1yqphzNmTjCbfDLRqjGAZTJGzu7/0yf/nwD//vv///3/uQf/qwD/2C9LNy7/yyD/1Cf/zCD/yx3/twmOcDL/3U//xhv/2TP//fT/0CP//vf/2jpYQi7/wxf/8rzswTD/3Ej/wBH/ogD//PD/ziL/pgD/+uX/8LT/++r/++3/+eJzWTH/9Mn/65v/6Y7/6If/3lX/99T/88T/77H/313/swH/99n/sAD/+Nv/5Xv/43H/xRb/qAD/9tH/8sD/5oH/20P/2kD/vAX/7aT/7KLEnjL/vxT/9c3/6pj/423/2Tf/+N//whO2kzP/8Lf/7aj/+ej/65//ug7/763/5Hb/4GH/3ln/0TH/7qr/4Wf/YF7/6pb/6ZT/vBH/9N3/W1//cVr/vgr/uQD/4WT/yDf/yBn/787/25D/1oL/xlL/klD/7Mb/6LpLzupRz+f/8tb/5I3/nEz22En/pEn/uxz/6Kr/4qn/36H/25j/5IP/3YH/Zlz/w0T/0EL/tEJXz+Nu0NSp1KLL1YD/0njS1nf/z3D/2Wz/0ln/rEb/4Jj/4mr/0mP/2FL/uT9cz+F00NB70cmw1Jy01Zf/fVb/zCj820r0kZJSAAAAHXRSTlMA4fZTEwX8hQLtyGhPppJ4Xd4rC6482tJuRDgcwyVjIgEAACEeSURBVHja7NhNCoJQFIbhU5KKZD+QRoPLJWnUMGggNgiailuI9r+JjhaB4I2zgPcZfHcDL1w4MkiX+XbugZF5mUcL+TnsPTCpjORrHXsgJEk/lXjgj0RUEXv1rCsHjFTNyfcikTTTt60dMKFrNY/ZQgqvbg6Y1F20j42sdF8OCLhqIDvJdO8OCGj6X0dmug8HBJz7O9uQydEBIV6RCcgEZIIpZAIDMoEBmcCATGBAJjAgExiQCQzIBAZkAgMygQGZwIBMYEAmMCATGJDJm/06xnEYBKIwfJKRphshg2ldpUTyAfYsuf6uERZJFC9Pihwb630NomAo+BsIwEwIwEwIwEwIwEwIwEwIwEwIwEwIwEwIwEwIwEwIwEwIwEwIwEwIwEwIwEwIwEwIwEyuwDLpSK+ZmCtMFrMr2gectLgV/NAu3Uz+E7Kx7DRz0o9eMxm1CLLwWljzgFqrEl3JqyFkFjSL6+xJdRpkm2k2MJOGa2RSrnHPmdw1S3dmcjZAJvakZjLbo88zCVp4YyYnA2SikPBpJlFXt1AZMzmDQzOJ6ypiXt+6h8qYyQHG+MdrkeJi0uJn2e2bSRVlTvqWj1q5msnsF5olvwjSgw4zGbTFvpXJOG1N3cjE6asoPbhwJkkfTTtkMukWx0wOg2ey34cYk37Zu4Mct0EoAMMneRI7hIDnLSuWSByAc3jp6zeRHwac2KWZui4z7180kTO2q/FXYntIB2omurCamclR9zFZTv/ll9NIa+qCyJmmGcBOa0HUGWudmOwz2ovdM8khMznqBia9X0lMJtGThi1b00sSvBABK5eRmdzefUyUphIdYv38I6+vITpaDszk9iI+suVq41kQFD6Di5jol0PshS2rp5C3SssC7pjwuckHXf4zneVyJjADLMrsF9MmjSxMxrul9mOYAOBpCuCrTEAakWK7gXjCRGEe79Zng8w6+d5MpDht+jKT9TZswPoVCzsmqJBeUbSJAABmpOFlOCYhX2ScZj9i4t5eEJ8xUY5ew7ISNEza22t5ExsTHk2uSVBXMDHvbq/JwgQifZ3P68sk9mzVKZN527JjJk3fiImi9WxZ34u2GU6ZoMg6aBdj9EOYeKwzf5EJLLsdM5P/oc+YTLruYyZI6AqTnRMPZ0wKtEiLDIzRD2Gy64tMbM1EN0pOmXjrlaBFkZnUfSsmCz07YOLhkAk10TOkvSQYo+GYLPpREFtOP/KilPQjvIaJfsME5k2JWutjMtCt+gGZPKpvjpu4Hiontrz89Paas88mkbPP/CuTxZLIlcW61GFe8YUJTmWPjpggjT9jNCATLUomf/QvVnQCQk5rWw07zcBjtjGnfyJBRNTaWoV5W6VJwhETXcOkbdEYNMZM2AGZxPT+CMppf2oi13afz7Fl0FnrZ3IyIy4hQB+TQNvS9DhGozGp312cFZR+HWVAi77U32CioJeJWR0zk+tqhwwTsT2CGERJX8Dk+JOEKB9pvyZlB5OV+AxjNBYT096j2DEBmWpFFzDB3m0eMElI+/LEBGGMxmKCYmuBhgllK0b3M3GmZaIh72uCiZlcV/mOy4bJ67nLou9nQjVMVr0JppGmm4zGpPr2OzPZlomER9HQqI62r+daB2ccsgk+ZuI8PdnGO0PvnxHGaDQm0lTvJ15QWi3eCA8QZ2+qn5XM5rz4Jx/n+pgJgixM9MpkrFlJwzGB6NyMWYdoMhDomYt9U+vVP2GiXpk4CCPNIxiPCWAEffCpl3ylMyNcwyRqyoh3GU3JYybL+nSs6SYDMiknKGlj4oiNJiZwERNKJVFy7R176pAJkmiaOj1IQzIJeUqaoEw7cdlfykR6UbUoV5vRsGZNKb5hMtZ0kyGZyHyEcHePJElS88LE27r0FSa6YYEA5IQKCC8VJkrN9fulUWqMS+IRmWQdCsslZz4xPPgQsYQ6/TkTHRoTiq7B6wweMlGiaZyLnRGZ5KMMhUlq//eZ35zCuk+ZWFpzfyriRVPQzOT+yEKomFh61PR40blJarDNsIWh9cNM7i/QsaiYzLSIlqSLmETXDiUlaWtAkpncXhRlBhilaVmQdJwuYlL2GOaTq2Tkc5P7UyEfjLQxoSmmRpr1MV7EBKaVoYU3YcrD3D7LTG5I4uKTkwWBhhQmjQDgQ9Ior7tvIl2elH0IJcjX8Y+Z3FdUOXnkSZ33wS9KQWcjHKe8w8O/hgRZN9Cv1RmZCXcUM+E6YiZcR8yE64iZcB0xE64jZsJ1xEy4jpgJ1xEz4TpiJlxHzITriJlwHTETriNmwnXETLiOmAn3i706NoEQCAAgWMrV4IGJkdVYhcU/fCAGym/w4UwNCxvIhEAmBDIhkAmBTAhkQiATApkQyIRAJgQyIZAJgUwIZEIgEwKZEMiEQCYEMiGQCYFMCGRCIBMCmRDIhEAmBDIhkAmBTAhkQiATApkQyIRAJgQyIZAJgUwIZEIgEwKZEMiEQCYEMiGQCYFMCGRCIBP+ZluPOY9zkwnv9jm+5i4T3uzjssuEZ8scl7nIhEfnuFllwqNj3Bwy4dEcdzLhdyZTJpjOh537WU0jiuI4/iT3dOt+LsxyUEYYBEEn4vg3DDqgYxkh/gFtiYkxCrroKruSpdAHKGTVdyu2tFjbUjtJ9P7O3M8zfHHOPfcmmh5htQP6QKwdQa/XtGPoZb0WX/yrvzf66k87+0OC+cfNer15+CC0RIiXydN96pv1o9CSIFYmT+vUDyw6GdU+t6uDu0mj7o8LhXwmQ0RGJuMWWvWy04xW4fB2JBItTibzbeqnNfJ3x7SCat+pX0j6t4u6E1WCmikSKU4mj6k9DwJSLxg4vk3/zW453iwnkiZOJl9Se7YCTXboNVx6FrfsBW9FgsTJZJvaNxdAeu1r36AXIcfNMDE/K3Ey2WBmYi6ilqSXNb4L0iIBkvLRyVW7eXoVdqNiCe4SMcLWvJak11TqXwrW+B+ILc+nExi/vxV8MV+v5Za+pFNpeWy/PvGW9Z8glvXmrGHQScmrkOdEG//q717xqz+r79IZ5Kc1wQ/ThwRmuyzpTGSH308Ky0yyqwKdlev1BCsMM8lNM3R2dpPVOMsuk1rRICUYDqNdCrNMrIkikezILptVCqtMrKZCkexIh8mxh1EmuWvFItkxJixmFDaZZCOblGQ0GZx6mGRiVi9IWfkK/B6FRyYLn5RWmglsHDKxHEmqK2PPsviZpAeKDiW/MiLkv+GAz+SmRSBKQwELPJPRVMFD8N/IIuxrfOxMhgWC4rYFJuRMskX1R9dDXcwlCnAmN2A/Jd+5kBMKbCamBzSV7JNTwGUbaiZWh2D5eDsU0ExCBV4exWdXBBjITEZNAudkBRTETCzFb3COUcJ6sQSYSZAnBuxQAMHLZAl6wjkkp0D/eQktk5FDbJRxBhSwTHJ1YmQM8wASK5PLd8RKfiEwQGUyhN6W/IkBcheIlEnIZHjdJ1cCAVAmS7z74GNAHHhwMomIqSJAJyiZmEViq6v+lTFIJiajdcnvysq/psbIJN0l1q5UX7RBZJJuEHMdxTtByIR/JV/Zu7udJoIoDuBPcs5GvTG9ky02Rk2pttFUEIGmFJVWhCiW0PCl4SMIYtFowhP4FsYHlK+WFdvuzG7bPTPz/93rBfmnO3PmzBnxvycGxCRj+RfnQln0OlZ+TOxevV5Zlrwvlh8T4zvVVD0VnBPxMbG2qmZUnU16TI7ZITsklfCYzNl5jtON2I572TFZsvBMuJe01L4C0TE5tK6/JExeaJ+S5JgUjbwkHM+EzL5HwTHJWdX3quqjyBkogmOyzU4qZ6hF49maH9efrXElJt/YUavUovkIVvM3XXEkJpuObXKupD9opuR2WyAnbsQka8UN0GjyVdLwpXm7rfmFWpyIiZvL15ZSgdT96vzcrxMx2WenLVPEN+Z/UosLMVlkx1VIWfN2wA9qcSAmWeeqr9f5VcQkTMbphUlreYKPTogGA09hCdvbV2crJkHpz1E2xO1CrPUxKTh44NfJTB3lNfS+hnuNYn13f9zqV+vlg8bRX7Pp1NHfVonh0oScZxCkxQS7nICnJIWwmFSxywkS85KkrJhkLJgf3U+7Um4Wy4qJs61I0m/uiIpJ0fmznOt8IaPtRcXE0e7XXtZJBEkxOUHJ5H8yXkAQFJOMwQ9uDc6uiLlsgmLygaGDWRJATky2phk6eFSk5MmJyR5DR/OUPDExqWMz3IUv4KFRMTE5YpB7tCMlJlkc5nSVrpI2S2Ni8Uj6+Mqkzc6Y4Mekl/QB6bIzJvgx6ek16bIyJvgxEf5zIiMm2OaEWCZNNsZkBTUT4bUTETHZYAgxRXosjEkOpzmh8nXSYlRMbn5/N+JNjob833MMofZIj0ExeTDunRv5RL28ZQg1kyMt5sTkgde2Rt0tMSiYIy3GxCQ17l15TF058ERbP7wiLcbEZM0LqFE3RZTW1FRJgzkxWfACxqmbWQbxe+IBxmTSC0pRZxmMM1GUL5A622KyySB/ETvAmNxV+ug48i5oP7wnDcbE5JnKEraOBayy9EtSZ0xMlDbEFQZlDVJnTEyUymsYAavhBakzJyY0Flqsz+LasI4TUmVSTM6P/kYmH95C0aQ/9kmZSTEJhelIWqYzpMiqmOCbY8hXJ2JM8LR9Mo5IkVUxwT7HkL1OojGp45uj65DU2BQTdDdq2yA1NsVkmcGMc50kY5LB9Rxt6RVSYlFMvjJoWyQlFsUEY7SMGbGVZEww4NOYLXGCMSmg1SSKLKmwJya4n2NOq6N+TPDCUhSGN9hrxQRLEwFKpMKamOTyDBGk66TAmpgcMBjzstsQYoJm6QsmN073MSYrs298v7SfpX/hgs6lxF9iahQExGRpgs/5FVLykSGSichF72ryMdn0ueWYFGyhuDbcAtss82LiMSlMa44dPGGIaDHqGMSNxGNS4YAprGAHqUHq5td35qq5y67j+cRjss4BMxRunyGiZd353f7bcppPlROPyS4HFVRyBcOow+4E/2HiMXmhG5MZhoj8HKkrBP7QfmXLsI/OCkNk1ch96RONYqIx+cYBU2hwHKhF0pB5w0H+9qFBG2LcvYhhI9Y1l/SxOeU19MHGMBXr16SaaLH+c7tYjxOdAVuPvjZZLQo4+nuUL+2/RE/SoJWirgYqBSIyqZEA02BjyJO6VVF1E00ZHPzFUdeuwrKMKqymIkMMBxpnOkeSznTQ4ThMS6RtVnEjfX9hvJaSEhPc0Rn6XZ09lbJcatQ79URKTFBdG/6UkwZXQ1Oy4J35JCUmeCs0gRFsqwUKMeqduSvmo7PKEMM2DcRz79TkmJwl7DxDDK9pIGpnKbkjaKeDWr3E0Vpns+PHJG2IywwxvKVBuOmdSkmKCQbCCpyFc+PseSxR5TXMqo9lmvoude9ZzTt1R1JMcOUvlkfUZw8WRrwLDyXFZJohhjz1VarmtY0iJvagvlrw2iZvICb2oH5auwhI7fvY48eyTogxX/ove/ey00QYhnH8Sp5vAsFNV1hqG8SkrZTU1GlHkCAqtqmaKjSSKmg8FDQQdMUaF9yAh7hy4eniZEZaiiKdmW+GvjN9ftfwTzvfWU4mztOdjSmJGwmYiZ4MgpOzx8HnRe43YSZyMmnbz0TL3JbEbxM9QX/AtphJDBWCziQnM5N5RRouIyDTY5ZhK8rMhLOwWsoIxjvjUFtmJncVaZgLuBKjLjMTrhALyKRidI0xkxh6iiCM2RMmxcTo1XTtosxMuC1Jy10EwbKHOKKPc3GTo5YH0JM4167VnG30CdGZcMu0liXoGG2bxiFT9uFQHsDQ8hwacqbRlZSdCY9zadmCf1eNXudFZ8LDoVqewLdnhs26UCzWjAMXRWeyqUjDTfhVSdp/NVcTODBpJVuy/3R4cYWWTfiVtis5F5X7TXgNjpbXOluQjGJkrsHhpVpaVnR+TOrRuS0JLxX5VtA512dUIpQJL/zUMK8zGE5H6O41ztbreKy1nzFKmfAycg2zOplUopQJ59cGMbs2ZRq1KF34yYdSdNyDX4mLkboXls8u6ajCPXGvmvfiI26hcfeIW1wy4ZOQoY6H45IJNyb59hD9xSUTPlft2yr6i0smfPw+1IFOXDJZ5+KfX1n0F5dMeD401JOhscmEqzphrujEJhN+w0bnC9ZrJtznOHibcCE2meQLikLbuhabTLgzKTJzsH4ymWrV0o1Gfaw4Cj2risLabDLoTCZNoyNZG+GzkC6JOKNzhpk0jB7JIjTMcIItIpNrOpk42vw4OWPX4Mqg/3Qss946V5nKtS3D1uJ+2LN1B64M/BO2q+gcR53mRsd+or7up5cJpuxOapjOFS8l4EOGV5J7lmrCDUmZOCdSk5ZxwHznJ5SHijy6DXckZQLL6EqP4sD5ykiCpzD+IeDsxSAzSRtH6qiMmd6mU1ZSirx5A3dEZeL8miTrNdP5PTmaTuH1sD2iPxzWzaRh/4qMAKNp45gW3NlRFM6la6IymbTM1rF7rc2GadhywEirVq+1pnGarCJPtuGSqEyOOHVYue50Sq7W+WSZ5rPVgZnLwCWhmTTsJ2wTnWGy64WfG4o82IBLUjOZtMxuDq2/OsH/ZTnW8WIXbgnN5Jgxw2a1cq20nUmCY51oj3P6ZaL/F1S0zCI3Tkd4s3SYmUyaRjoBN1a46cS11C24FolMkJjmcZ0OMc+jyMvEvTVFkrc3Cskkc02RK4UZuBe3TDh1InpLvZhMSvyIDeGi+thlgiVFcjckicmE53Wkf8CKyIRPnLtxPQ8vYpgJ9zq68AqexDCT/JyiPgor8CSGmfAdUdmjYSmZNHnVidzlHDmZYEuRtBuDBWaS5RTbqVKv4VEsM8GsolMswat4ZsKfE9E/JlIy4c/JaRbgWUwz4c+J5B8TMZlgQ5HQYY6kTEq87OQ/Jm5h4MRkwiu2hE7ACstkhis7J7pcwuDJyQTLik5wAwIIyiTDE4AnmFuHAIIywS4PFP9rGRJIygTPFck5wiU2Ew6K/zZRhQiiMsFbRce8gAyyMsnw9qRjXs5ABlmZoMqlnV6bEEJYJnikqOsKpJCWyfq8okPlFUghLRN85eSJrCkTmZngjiIZOxtFZzLDC08c1yUs+YWRyVYeQdjmaOdASswoJ+hM1IMSHKUqX56Nwy6TkDJR19eA/PJCaptLxZrmpUyshZGJSq1ulJV6Cj3ZoV/bkbKWE0omHTvQdE8NuUXIEmQmBfXHRIn77CO/lz6sTDKLqeAG/Pmh/jwR9mESZCalhUCf88iW1dAqCPswCTCT5bLqSt2HvrWhnbRPCZqkDzaTzKzqVc5yi1L0tyIFnwnya6u3J1TX7Tx3xvq1kIGO/Z/f9/Y+ftoXmYmtuai6NsDPWH+eNqHjy4dxx/vPUjNBvmAH0nQgAKUhXAQs39KrZG+847PUTLCg1Pw6glMdutnYwjZ0ND+Md73fl5rJjprYRZDuD9liceoetPwa7/FJaibVwO9Cvjlcw+JF6Pkx3uOj1EwySxk4eLPwYIbC38Z77EnNBHn8wa32fsxmhiSTDu6N/c3e2ay2DURR+EnOvIQEWgoLGYQh4D8k1VGKkQW2UxSwZYPdktQ41Lvu87hV0qxKF2pj2XPuzPcMHzN3zr0z8x9EHmDEptMKniF/i/7esE0oYdvBWygDiDt4w4ADcUt0DPjmbd7FO/LjtXesJx+yRHpY3x4d4fvOqoElzVt/Ly86t/7+wNaxjVlpN61Gqgk8wY/aZx3oDosmgnO2nQft4dEEa5n9nT2BJUyaYCmwX+yewACTJqjEzZ84M1BApQk+f1WiuHkGB1yaoCdqPnbrgwQyTbARFKDE2scltJoAP4QUsi7FEYdWExQi7o2GGt7tE6UJfAFvUY/1uycsTRNs6CfaIp6yhFcTYEmdoIS6vXIjVRP4c0VLfgAbrJrAS0hPPO5R/4awHE2An5RXjIcFCCHWBN0BX894oc93BaZoAhRkC8qIpNMnTBNsjkQVijv4AlLINQG+54qEfgVa6DVBZx0qApxSi3+njdUE8CP9S9l4AmYkaAI8a97lGWv164mxmsD7NFLaEqSEgZpITYBuqWmJ4txxRiUyNQF6jxoejp0dzSCjIZoA/kAzUdyIu3KVqQng7zQSxV3wtYLN0ASY6LKiOBHXgJpZmgC9vQYzS+GdkO1GrCZA99RXV2WYCDjdiNcE8Gaxq66EO1/S5ySGaFLjPwzVFbjZi9ptxGsCeE+Zoy6Ku5K3kIjXpKa3nqqLsU1ERGkGalLjJ7m6AOMHMSGJkZrUTNo2ZVwKykiM1aTGT7NAtUKYpWL3GuM0qelUZe6euxw5FjJrVnM1eeV+9nguVdzt3bIHQzBMk1e6VZJ9MFIZxd8K2il5q0lz7oskmobqn3HyKHkyZhExXpM3vEmRltHtyG2Srk4X+7SYEL1wZDU5M5tDNUuT4y67zfvDIHBUjRMEo34+jaNBeVpWB+bbE1YTy1+xmlgaYDWxNMBqYmmA1cTSAKvJL/buZjdtIArD8AAGQiB/0B+adPRJXbKzJVsqFRISCxapyiVE2bBm1VX23HZtg0QgwRxVqpRm3mc560+2Z3zOGRgQExgQExgQExgQExj8u5g8zAkKXhXPJ9uYlJbr2AN7vq0ySbuYFJIHHil4Jk4T6TAmhaeRB0qjVaId14z6vfbXlkqLXx7IzZYqtc7bjX7UdBvR8EaFZO4BP01UqF3duX1n1zUV1h7Bm6vQ6TbdS4NLcoJdSi4i97pGXTneO4GbKtfquqNuO8r98AjYLJFU77kKt3VJC/bFIVtKavVcpYZyqUew1sp13QmXys08AhUnki7cKYMbSY8egUoldSJ3Uk+UFoRrnBheOYWzz5KePIJ0L6nWdAbXkhYeQcokXTmLQZ2zk1DFklp3zuSDpHuPAE0lnTubIXudUE0ktZ3NRz5OQvUoqeFsIkmJR4AWkvrOqC6J/zoh+ikpckYdSWNfijMdSFLW39t6NvYbyjX/IiYTvfSd9fe2nh7ExP7SISYBracVLx3LJ2yc6VD6f6+/hYf8W1vPxs8/YdkQw7Ah5ngNluM1DutRaV4e1vPrD5ZffxQSwFBIQFkSLGVJFDnCUORIyTQqTTYl0zRgwNKAQTsXLO1cNIeiwmi5bSGm1RwnW82/OOcYXAHT4IojY3A4MsH+GByGauGY30eGakXDT4zow9ERfQz8hGXgZ007KTthbI3WiXIMI0e1eJKowNUGqDReZZK4KAWnxPOUa5fA7VwgJn/Yu7vWpqE4juOvJAdysvbi3AVXxCRCaQuVhRWhoiAqogYFozjFIt1QdyOFFre2rNBd7Jntaswxtkt9aybdLtrZh3TNCf4Pv89r+HKSc/JPAqMgE4gAmUAEyAQiQCYQATKBCJAJRIBMIAJ1MxFXOAwQV7TpqJiJ0B6/XP7y+sFijsGgW4v3X7y+937/+20+VSuqZSLE9x8PFxlMUFj6+IzzyKWolYn48/Ezg4iqyxdRQ1Eqk5dL8wym0d2/HakUdTK5vf+CwdSqm6sRQlElE/HyAYMbKW+afFInamQiHr9mcGPPv1kTQlEjk0e3GMxgfnt1fCcKZCIWlhjM6PmFJcaEQj8T8anMYGa5A33MgkI+E7GJTXA8lsd0Qj0TscwgJk9Na1Qn1DN5yiA2b1ZHdUI8E1QSqyej1hPSmYh3DGLVyQ/vhHImYpNBzN4P74RwJuIT9jjxOzCG7XfoZiIWMFYiQeF0WCd0M9Fw9irF59Uh5ydkMxE/GEixXTKVyURcFBhIMX/+72WHbCYPGUhS+61zbRDRTMRXBtI0S9d3xUQz4ZiMlqi8ev2yQzMTsc9AojPbVCETjuloqcq/ry0nJDMRrxhIdWCb9DPhTxhIVUsZXOtDMROxgAlp2U4HlxOSmeAAVrodZ+DshGAmgj9nIFk5OzBRQDGTBQwQDEHpqjM8Exya0HPm9N/EEsyEf2Eg3Xo233d0Qi8TYd1nIF0ha5ukM3nLIAGnjk46k18MEtDqP2GjlwnHPH0idrN50plsM0hAx+ubOiGXibDeMEhAt2ibhDMxMVGfiGrF1glnotcYJKDgOqQzqTJIAjKBSJkYyAQmcVPIBCZK952vEcwEt7CJKBDPZJ1BAqpp2hcdHK8lopumfQuLw/pEdIhviPHoLxG7tDMxMUiQiBbtw3rriEEC2qQf/Wk8jyHHBBQ+kB4k0LiBkekErNdpjyUJ/YCBdHtp2kOOQj/C61zytSvER6atUpeBZGXfo/0ChsaNJgPJdurEX+cKrzr4cIVsbZf6y6HCtDcYSFXzi+RfNed5HMRK1qqT/3CFJvQ7mDmRqrzlkv8MTrjXwdGJVE3fo/9RLY0bWE4kChcTBT7RpwmzhLsTiVq+p8IHPzVuONjsSFNbcVMqfD44vDs5wo9SJJlv+54aHyPXuO7gKFaSnYzrqPFrA01Y+RQm7KWobdWzqvwoRRO6fVRmELtc2y/aqvx2SRPccM4xUBC/44ybUucnbuFlZ63FIGa7jXRWoV9C9p4AZncZxKqTqXu2Sj+Y1QTX7SJe7YrVxopfdBT7XXV4e5LdYRCbzpZfcRT7+f1lJ8UzBrEdmASVDJ8foJyJJqygkxb2O/HYmxtdCelMep145zg/iUHuZFwltDO57OQnHgPOrHvYqHujKyGeSXh/Ymc/NDFDPZP53a1M2rONkZVQz6S3L16rHOIBzwy67TnfXRt3XkI+k6ATM+946ZMHDG6k2prLpIup0rhK6GeiCWEZwYLy4RiDjzdwv7XV8N1seMEZU4kCmfQuPHnHc+snG9gcT2f9eCWIxHMmLSVKZNJbUEphKD+bWFIiq+4dzoWRpGzDmlCJGpn07lAM2/Eqaf+wubHIYILcRrMdNFKvhJGYEyNRJZPLUErOmufWff/wZK+zXivnGFyTW6ytd/aO23fDRtzimlMKI5lYiTqZhKFYet4OSqmkg1QyjcYcDNFoZHy/nq54WcfO61akSFTKJAhFcDMoJUzFq7huGoZw3YrnraWCRqIvJGplEoYSrilGvhS0EkjBNU7Atkt5Qzd59EhUy+RqTeGWaeq6bsA/9IBpcS6maUTFTELiCodB4pI2HVUzgf8ZMgFkAsgERkEmEAEygQiQCUSATCACZAIRIJO/7dU9CsJAFEXhpyE/CMYEopJiGAipLO1CGsE2ZAvi/jfhGwUhkJHX2J2vuCs4cGFAJjAgExiQCQzIBAZkAgMygQGZwIBMYEAmMCATGJAJDP6Xyd0BEZ0GspWd7s0BEaMGspFS9+mAiF4DaaT1anDAqvmqfVRShNeZ6ASr5il8TipyzLx6DJ0DFi5j74NE1MEDP+Tylnsgqizkoz17YNUpka8i2ddbDyxkdVOlErwAr78eHtMdxMgAAAAASUVORK5CYII=\") 50% no-repeat;background-size:contain}#got-award .img{width:2.66666667rem;height:2.66666667rem;margin:0 auto;background:50% no-repeat;background-size:contain;margin-top:.93333333rem;margin-bottom:1.66666667rem}#got-award .title{font-size:.29333333rem;font-weight:300;color:#666;text-align:center;margin-top:1.4rem;padding:0 .13333333rem}#got-award .title p{line-height:.42666667rem}#got-award .get-code,#got-award .go-coupon,#got-award .show-code{height:1.2rem;width:3.46666667rem;font-size:.42666667rem;line-height:1.2rem;color:#333;text-align:center;cursor:pointer;white-space:nowrap}#got-award .go-coupon{text-decoration:none;display:block}#got-award .cancel{height:.42666667rem;width:.42666667rem;display:block;position:absolute;cursor:pointer;right:.26666667rem;top:.26666667rem;margin:auto;background:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAG1BMVEUAAAD/nQD/nQD/nQD/nQD/nQD/nQD/nQD/nQBp49sjAAAACHRSTlMA+lRO5OZKRmZuoqgAAACQSURBVCjPVdIxCsJAFIThId5gBUlpbqCgJxB0extbwYsEIrxjp5gJP9luH98ODPt0f0ic21uf+cx9GP/q1RhMtehbJgZ10mGsBpgv0tXE4CiFAEwAIQCIASQAAnBcAyQvABIACWBAozzZGhFqQs3JhJpDCDVDqGkCCAGYACABkABIAPHdgK/sASGLfs/dOrxWWGE8Y5j7B3UAAAAASUVORK5CYII=\") 50% no-repeat;background-size:contain}#got-award .link{display:inline-block;cursor:pointer}", ""]);
	
	// exports


/***/ },
/* 179 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.show) ? _c('div', {
	    attrs: {
	      "id": "got-award"
	    }
	  }, [_c('div', {
	    staticClass: "mask",
	    on: {
	      "touchmove": _vm.touchMove
	    }
	  }, [_c('div', {
	    class: ['content', _vm.code ? 'code' : '']
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('p', {
	    staticClass: "of"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('p', {
	    staticClass: "of"
	  }, [_vm._v("有效期" + _vm._s(_vm._f("time")(_vm.coupon.startTime)) + " - " + _vm._s(_vm._f("time")(_vm.coupon.endTime)))])]), _vm._v(" "), _c('div', {
	    staticClass: "img",
	    style: ({
	      backgroundImage: ("url(" + _vm.img + ")")
	    })
	  }), _vm._v(" "), (_vm.awardType === 1) ? _c('div', [(!_vm.code) ? _c('router-link', {
	    staticClass: "link",
	    attrs: {
	      "tag": "div",
	      "to": {
	        path: '/info',
	        query: {
	          awardId: _vm.awardId,
	          from: 'turnplate'
	        }
	      }
	    }
	  }, [_c('div', {
	    staticClass: "get-code",
	    attrs: {
	      "data-awardid": _vm.awardId
	    }
	  }, [_vm._v("获取兑奖码>>")])]) : _c('router-link', {
	    staticClass: "link",
	    attrs: {
	      "tag": "div",
	      "to": {
	        path: '/awards'
	      }
	    }
	  }, [_c('div', {
	    staticClass: "show-code"
	  }, [_vm._v("兑奖码:" + _vm._s(_vm.code))])]), _vm._v(" ")]) : (_vm.awardType === 2) ? _c('div', [_c('div', {
	    staticClass: "link"
	  }, [_c('a', {
	    staticClass: "go-coupon",
	    attrs: {
	      "href": _vm.couponLink
	    }
	  }, [_vm._v("立即使用")])])]) : _vm._e(), _vm._v(" "), _vm._v(" "), _c('i', {
	    staticClass: "cancel",
	    on: {
	      "click": _vm.cancel
	    }
	  })])])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(181)
	
	/* script */
	__vue_exports__ = __webpack_require__(184)
	
	/* template */
	var __vue_template__ = __webpack_require__(188)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(182);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(71)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1bf0100b!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./intro.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-1bf0100b!../../../node_modules/less-loader/index.js!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./intro.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(66)();
	// imports
	
	
	// module
	exports.push([module.id, ".intro{width:100%;overflow:hidden;box-sizing:border-box;padding:.61333333rem .4rem}.intro .intro-detail .title,.intro .intro-shop .title{font-size:.37333333rem;font-weight:500;color:#333;height:.58666667rem;line-height:.58666667rem;margin-bottom:.32rem;position:relative}.intro .intro-detail .title:before,.intro .intro-shop .title:before{position:absolute;top:.08rem;content:\"\";display:inline-block;width:.13333333rem;height:.42666667rem;border-radius:1.33333333rem;background-color:#fe5a4c}.intro .intro-detail .no-detail,.intro .intro-shop .no-detail{font-size:.42666667rem;color:#999;line-height:.64rem;font-weight:500;width:100%;text-align:center;margin-top:.8rem}.intro .intro-shop .content{display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.34666667rem;color:#fff;background:url(https://si.geilicdn.com/hz_img_07680000015bdbfc75350a02685e_690_240_unadjust.png) no-repeat 50%;background-size:contain;margin-bottom:.85333333rem;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.intro .intro-shop .content img{width:1.86666667rem;height:1.86666667rem;margin:.66666667rem .32rem .66666667rem .4rem;border-radius:.05333333rem}.intro .intro-shop .content .content-info{-webkit-box-flex:1;-ms-flex:1;flex:1}.intro .intro-shop .content .content-info p{width:3.73333333rem;font-size:.42666667rem;font-weight:500;line-height:.58666667rem;margin-bottom:.08rem}.intro .intro-shop .content .content-info span{display:block;width:3.46666667rem;font-weight:300;line-height:.49333333rem;padding-bottom:.08rem}.intro .intro-shop .content .content-info .of{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.intro .intro-shop .content .content-info .of2{overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;text-overflow:ellipsis;word-break:break-all}.intro .intro-shop .content .content-info .grade{background-size:contain;background-repeat:no-repeat;background-position:50%}.intro .intro-shop .content .content-info ul{width:3.73333333rem;height:.29333333rem;text-align:left;padding-top:.08rem}.intro .intro-shop .content .content-info ul li{width:.32rem;height:.29333333rem;display:inline-block;padding-right:.08rem}.intro .intro-shop .content .content-info .red-grade{background-image:url(https://si.geilicdn.com/68c36c9ef354f759403b2e882581e437.png)}.intro .intro-shop .content .content-info .green-grade{background-image:url(https://si.geilicdn.com/d907f613aaa57bb3d88ef6090e37bc3b.png)}.intro .intro-shop .content .content-info .green-crown-grade{background-image:url(https://si.geilicdn.com/91f1ecef3f2afd3d77cbebd117529482.png)}.intro .intro-shop .content .content-info .yellow-crown-grade{background-image:url(https://si.geilicdn.com/38e24c72e006365272ab630722e09529.png)}.intro .intro-shop .content .shop-btn{color:inherit;display:block;text-decoration:none;font-weight:300;height:.69333333rem;line-height:.69333333rem;border:1px solid #fff;background:hsla(0,0%,100%,.1);border-radius:.05333333rem;padding-left:.66666667rem;padding-right:.21333333rem;margin-right:.30666667rem;background:url(" + __webpack_require__(183) + ") no-repeat;background-size:.37333333rem .36rem;background-position:.18666667rem}.intro .intro-detail section{font-size:.34666667rem;font-weight:300;color:#333;line-height:.52rem}.intro .intro-detail{margin-bottom:2.22666667rem}.intro .intro-btn{position:fixed;padding-bottom:.53333333rem;bottom:0;left:0;right:0;text-align:center;background-color:#f4f4f4;overflow:hidden}.intro .intro-btn button{border:none;background:none;width:9.2rem;height:1.17333333rem;line-height:1.17333333rem;color:#fff;font-size:.42666667rem;background-color:#fe5a4c;border-radius:.05333333rem;margin-bottom:.16rem}.intro .intro-btn p{font-size:.32rem;font-weight:300;color:#999;line-height:.52rem}", ""]);
	
	// exports


/***/ },
/* 183 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAbCAMAAABY1h8eAAAAh1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9qkf8RAAAALHRSTlMAwEY5LPyCmd65+de8NxsUEQ0L5bVrUwf27enPy6KfeXRlX1kxIauPjoyLTpmjAdAAAADYSURBVCjP5ZJnrsJAEIMnm60JCen08iiv4fufDzIDf9jcgE+KbMmSPYqWHujvJOZ3QYxvJ0JjORtwo5hZzpJ4muALelzEcSqcc69bViTEvdXSsZ/s/Xl8jC1FS/vqddQ9z7liJ2aHqxgfyGYN2zNmzy2cWZvM0sXwZuXXUKNRWHu+0JkLkUUYir7Nio35V+rPbIqs7YshgLdPKwBbTbUzgHE16S2A1YkErUqZSdNGLlb69S/2NUXU+zmrQhqHKdRHhRp9HB6gxQTkyRs5AgmLY/cedofxwd8BTpMQq/SShrcAAAAASUVORK5CYII="

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _wxsdk = __webpack_require__(185);
	
	var _wxsdk2 = _interopRequireDefault(_wxsdk);
	
	var _common = __webpack_require__(74);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _api = __webpack_require__(97);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'intro',
		data: function data() {
			return {
				description: '',
				shopId: this.$route.params.shopId || '',
				shop_info: {},
				shop_credit: {},
				gradeType: ''
			};
		},
	
		methods: {
			getShopInfo: function getShopInfo() {
				var self = this;
				_common2.default.jsonpVap({
					url: _api2.default.getShopInfo,
					dataIn: {
						shop_id: self.shopId,
						get_module: ["shop_info", "shop_credit"],
						source: "weidian-zhanhui"
					},
					ok: function ok(res) {
						self.shop_info = res && res.result.shop_info;
						self.shop_credit = res && res.result.shop_credit;
						switch (self.shop_credit.credit_type) {
							case 1:
								self.gradeType = 'red-grade';
								break;
							case 2:
								self.gradeType = 'green-grade';
								break;
							case 3:
								self.gradeType = 'green-crown-grade';
								break;
							case 4:
								self.gradeType = 'yellow-crown-grade';
								break;
							default:
								self.gradeType = '';
						}
					},
					error: function error() {}
				});
			},
			open: function open() {
				_wxsdk2.default.openApp();
			},
			goShop: function goShop(url) {
				location.href = url;
			}
		},
		created: function created() {
			document.title = "活动介绍";
			this.getShopInfo();
			var description = window.sessionStorage.getItem('description');
			this.description = description && description.replace(/\\n/g, '<br />').replace(/\\r/g, '<br />') || '';
		}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _wxconfig = __webpack_require__(186);
	
	var _wxconfig2 = _interopRequireDefault(_wxconfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = __webpack_require__(97);
	var url = config.host + '/m/hudong-h5/#/index/list';
	var _window = window;
	_window.wx = '';
	exports.default = {
	    appLink: 'kdweidian://weidian.com?type=4&url=' + encodeURIComponent(url),
	    initWXSDK: function initWXSDK() {
	        var _this = this;
	        (0, _wxconfig2.default)({
	            cb: function cb() {
	                _window.wx = wx;
	                _this.launchApp();
	            },
	            apiList: ['launch3rdApp', 'getInstallState']
	        });
	    },
	    launchApp: function launchApp() {
	        // 在微信中，调用微信jssdk打开APP
	        _window.wx.invoke('launch3rdApp', {
	            'appID': 'wx2e5df03e8b9c6525', // 微店
	            'messageExt': this.appLink,
	            'extInfo': this.appLink
	        }, function (e) {
	            var errMsg = e.err_msg || e.errMsg;
	            if (errMsg.indexOf('launch_3rdApp:ok') < 0) {
	                // 唤起APP失败，跳转到下载页
	                location.href = '//m.weidian.com/';
	            }
	        });
	    },
	    openApp: function openApp() {
	        var ua = _window.navigator.userAgent;
	        if (/MicroMessenger/i.test(ua)) {
	            if (_window.wx) {
	                this.launchApp();
	            } else {
	                this.initWXSDK();
	            }
	        } else {
	            location.href = this.appLink;
	            setTimeout(function () {
	                location.href = '//m.weidian.com/';
	            }, 2000);
	        }
	        // e.stopPropagation();
	        // e.preventDefault();
	        // return false;
	    }
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(187);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _api = __webpack_require__(97);
	
	var _api2 = _interopRequireDefault(_api);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultApiList = ['launch3rdApp', 'getInstallState', 'checkJsApi'];
	function _loadScript(src, callback) {
	  var script = document.createElement('script');
	  script.async = "async";
	  script.src = src;
	  if (callback) {
	    script.onload = callback;
	  }
	  document.getElementsByTagName("head")[0].appendChild(script);
	}
	
	function WX(opts) {
	  opts = opts || {};
	  opts.apiList = opts.apiList || defaultApiList;
	  _loadScript('//res.wx.qq.com/open/js/jweixin-1.1.0.js', function () {
	    _promise2.default.ajax('POST', _api2.default.api + 'weixin/getjsconfig/1.0', {
	      url: location.href.split('#')[0],
	      mpid: 'gh_c6feb778444d'
	    }).then(function (err, res) {
	      if (!err) {
	        res = JSON.parse(res);
	        if (res.status.code == 0) {
	          var args = res.result;
	          wx.config({
	            beta: true, // 必填，开启内测接口调用，注入wx.invoke和wx.on方法
	            debug: false,
	            appId: args.appId,
	            timestamp: args.timestamp,
	            nonceStr: args.nonceStr,
	            signature: args.signature,
	            jsApiList: opts.apiList
	          });
	          wx.ready(opts.cb);
	        }
	      }
	    });
	  });
	}
	
	exports.default = WX;

/***/ },
/* 187 */
/***/ function(module, exports) {

	"use strict";
	
	function Promise() {
	    this._callbacks = [];
	}
	
	Promise.prototype.then = function (func, context) {
	    var p;
	    if (this._isdone) {
	        p = func.apply(context, this.result);
	    } else {
	        p = new Promise();
	        this._callbacks.push(function () {
	            var res = func.apply(context, arguments);
	            if (res && typeof res.then === 'function') res.then(p.done, p);
	        });
	    }
	    return p;
	};
	
	Promise.prototype.done = function () {
	    this.result = arguments;
	    this._isdone = true;
	    for (var i = 0; i < this._callbacks.length; i++) {
	        this._callbacks[i].apply(null, arguments);
	    }
	    this._callbacks = [];
	};
	
	function join(promises) {
	    var p = new Promise();
	    var results = [];
	
	    if (!promises || !promises.length) {
	        p.done(results);
	        return p;
	    }
	
	    var numdone = 0;
	    var total = promises.length;
	
	    function notifier(i) {
	        return function () {
	            numdone += 1;
	            results[i] = Array.prototype.slice.call(arguments);
	            if (numdone === total) {
	                p.done(results);
	            }
	        };
	    }
	
	    for (var i = 0; i < total; i++) {
	        promises[i].then(notifier(i));
	    }
	
	    return p;
	}
	
	function chain(funcs, args) {
	    var p = new Promise();
	    if (funcs.length === 0) {
	        p.done.apply(p, args);
	    } else {
	        funcs[0].apply(null, args).then(function () {
	            funcs.splice(0, 1);
	            chain(funcs, arguments).then(function () {
	                p.done.apply(p, arguments);
	            });
	        });
	    }
	    return p;
	}
	
	/*
	 * AJAX requests
	 */
	
	function _encode(data) {
	    var payload = "";
	    if (typeof data === "string") {
	        payload = data;
	    } else if (data instanceof FormData) {
	        return data;
	    } else {
	        var e = encodeURIComponent;
	        var params = [];
	
	        for (var k in data) {
	            if (data.hasOwnProperty(k)) {
	                params.push(e(k) + '=' + e(data[k]));
	            }
	        }
	        payload = params.join('&');
	    }
	    return payload;
	}
	
	function new_xhr() {
	    var xhr;
	    if (window.XMLHttpRequest) {
	        xhr = new XMLHttpRequest();
	    } else if (window.ActiveXObject) {
	        try {
	            xhr = new ActiveXObject("Msxml2.XMLHTTP");
	        } catch (e) {
	            xhr = new ActiveXObject("Microsoft.XMLHTTP");
	        }
	    }
	    return xhr;
	}
	
	function ajax(method, url, data, headers, noContentType) {
	    var p = new Promise();
	    var xhr, payload;
	    data = data || {};
	    headers = headers || {};
	
	    try {
	        xhr = new_xhr();
	    } catch (e) {
	        p.done(promise.ENOXHR, "");
	        return p;
	    }
	    xhr.withCredentials = true;
	
	    payload = _encode(data);
	    if (method === 'GET' && payload) {
	        url += '?' + payload;
	        payload = null;
	    }
	
	    xhr.open(method, url);
	
	    if (!noContentType) {
	        // 默认content-type。FormData图片上传默认用 content-type: multipart/form-data;
	        var content_type = 'application/x-www-form-urlencoded';
	    }
	    for (var h in headers) {
	        if (headers.hasOwnProperty(h)) {
	            if (h.toLowerCase() === 'content-type') content_type = headers[h];else xhr.setRequestHeader(h, headers[h]);
	        }
	    }
	    if (!noContentType) {
	        xhr.setRequestHeader('Content-type', content_type);
	    }
	
	    function onTimeout() {
	        xhr.abort();
	        p.done(promise.ETIMEOUT, "", xhr);
	    }
	
	    var timeout = promise.ajaxTimeout;
	    if (timeout) {
	        var tid = setTimeout(onTimeout, timeout);
	    }
	
	    xhr.onreadystatechange = function () {
	        if (timeout) {
	            clearTimeout(tid);
	        }
	        if (xhr.readyState === 4) {
	            var err = !xhr.status || (xhr.status < 200 || xhr.status >= 300) && xhr.status !== 304;
	            p.done(err, xhr.responseText, xhr);
	        }
	    };
	
	    xhr.send(payload);
	    return p;
	}
	
	function _ajaxer(method) {
	    return function (url, data, headers) {
	        return ajax(method, url, data, headers);
	    };
	}
	
	var promise = {
	    Promise: Promise,
	    join: join,
	    chain: chain,
	    ajax: ajax,
	    get: _ajaxer('GET'),
	    post: _ajaxer('POST'),
	    put: _ajaxer('PUT'),
	    del: _ajaxer('DELETE'),
	
	    /* Error codes */
	    ENOXHR: 1,
	    ETIMEOUT: 2,
	
	    /**
	     * Configuration parameter: time in milliseconds after which a
	     * pending AJAX request is considered unresponsive and is
	     * aborted. Useful to deal with bad connectivity (e.g. on a
	     * mobile network). A 0 value disables AJAX timeouts.
	     *
	     * Aborted requests resolve the promise with a ETIMEOUT error
	     * code.
	     */
	    ajaxTimeout: 0
	};
	
	module.exports = promise;

/***/ },
/* 188 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "intro"
	  }, [_c('section', {
	    staticClass: "intro-shop"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v("  活动举办方")]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('img', {
	    attrs: {
	      "src": _vm.shop_info.shop_logo
	    }
	  }), _vm._v(" "), _c('section', {
	    staticClass: "content-info"
	  }, [_c('p', {
	    staticClass: "of"
	  }, [_vm._v(_vm._s(_vm.shop_info.shop_name || '微店卖家'))]), _vm._v(" "), (_vm.shop_info.weixin != '') ? _c('span', {
	    staticClass: "of2"
	  }, [_vm._v("微信：" + _vm._s(_vm.shop_info.weixin))]) : _vm._e(), _vm._v(" "), _c('ul', _vm._l((_vm.shop_credit.credit_num), function(item) {
	    return _c('li', {
	      staticClass: "grade",
	      class: _vm.gradeType
	    })
	  }))]), _vm._v(" "), _vm._v(" "), _c('a', {
	    staticClass: "shop-btn",
	    attrs: {
	      "href": _vm.shop_info.shop_url
	    }
	  }, [_vm._v("进店逛逛")])])]), _vm._v(" "), _c('section', {
	    staticClass: "intro-detail"
	  }, [_c('p', {
	    staticClass: "title"
	  }, [_vm._v("  活动详情")]), _vm._v(" "), (_vm.description != '') ? _c('section', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.description)
	    }
	  }) : _c('section', {
	    staticClass: "no-detail"
	  }, [_vm._v("暂无详情")]), _vm._v(" ")]), _vm._v(" "), _c('section', {
	    staticClass: "intro-btn"
	  }, [_c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v("我也要创建")]), _vm._v(" "), _c('p', [_vm._v("注：本活动和奖品由商家支持，微店仅提供技术支持")])])])
	},staticRenderFns: []}

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(190);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(67)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!../../../node_modules/postcss-loader/index.js!./index.less", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/less-loader/index.js!../../../node_modules/postcss-loader/index.js!./index.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(66)();
	// imports
	
	
	// module
	exports.push([module.id, "a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}*{-webkit-tap-highlight-color:rgba(0,0,0,0)}a,img{-webkit-touch-callout:none}body{font-family:-apple-system,BlinkMacSystemFont,PingFang SC,Hiragino Sans GB,Microsoft Yahei,\\\\5FAE\\8F6F\\96C5\\9ED1,sans-serif;margin:0;padding:0}input,textarea{-webkit-appearance:none}@media screen and (max-width:239px){html{font-size:12px}}@media screen and (min-width:240px){html{font-size:12px}}@media screen and (min-width:320px){html{font-size:16px}}@media screen and (min-width:360px){html{font-size:18px}}@media screen and (min-width:375px){html{font-size:18.75px}}@media screen and (min-width:400px){html{font-size:20px}}@media screen and (min-width:480px){html{font-size:24px}}@media screen and (min-width:540px){html{font-size:27px}}@media screen and (min-width:640px){html{font-size:32px}}@media screen and (min-width:750px){html{font-size:37.5px}}#main{max-width:10rem;margin:0 auto}html{min-height:100%!important;background-color:#f5f5f5!important}body{-webkit-overflow-scrolling:touch;overflow-scrolling:touch}*{-webkit-tap-highlight-color:transparent;-webkit-appearance:none;outline:0}#not-weixin{display:none;padding:.53333333rem;padding-top:2.08rem;font-size:14px;line-height:18px;text-align:center;color:#999}", ""]);
	
	// exports


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** seller/index.js
 **/